import { useState, useEffect, useCallback, createContext, useContext, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useNavigate, useParams, useLocation } from "react-router-dom";
import axios from "axios";
import Cropper from "react-easy-crop";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

console.log('BACKEND_URL:', BACKEND_URL);
console.log('API:', API);

const BG_WOMAN = "https://customer-assets.emergentagent.com/job_719a9ef7-68bc-49c1-a600-6a34e3c3c8d3/artifacts/nh6a22p2_woman.jpg";

// Sex / dating article content (static for now)
const ARTICLES = {
  "positions-trending": {
    icon: "🔥", title: "Top Sex Positions Trending Right Now",
    teaser: "What's hot right now — and why people love these moves.",
    content: [
      "Trends come and go, but a few positions keep popping up because they hit the sweet spot: comfort, control, and intensity.",
      "1. The Lotus — Face-to-face connection with deep intimacy. One partner sits cross-legged while the other wraps around them. Perfect for slow, connected sex.",
      "2. Prone Bone — A fan favourite for deeper stimulation. One partner lies flat while the other positions from behind. The angle changes everything.",
      "3. The Pretzel — Side-lying position that allows for eye contact and closeness while keeping things comfortable for longer sessions.",
      "4. Standing Ovation — Against a wall or surface, this position adds excitement and spontaneity to any encounter.",
      "5. The Bridge — A yoga-inspired position that's all about flexibility and new angles. Not for beginners, but worth the effort.",
      "Remember: communication is everything. What works for one couple might not work for another — and that's perfectly fine.",
      "Pro tip: talk about what you want BEFORE you're in the moment — it makes everything smoother."
    ]
  },
  "confidence": {
    icon: "💎", title: "Sex Confidence That Actually Works",
    teaser: "Confidence isn't loud — it's calm, clear, and honest.",
    content: [
      "The most attractive confidence is simple: you know what you want, you communicate it, and you don't pressure anyone.",
      "Know Your Body — Spend time understanding what you enjoy. Self-awareness is the foundation of confidence.",
      "Communication is Sexy — Asking 'do you like this?' shows you care. That's attractive, not weak.",
      "Ditch Comparison — Real life isn't a performance. Stop comparing yourself to unrealistic standards.",
      "Embrace Imperfection — Laughing together when something doesn't go as planned is intimate and real.",
      "Set Boundaries — Knowing and expressing your limits is one of the most confident things you can do.",
      "Focus on Connection — The best experiences come from two people genuinely present with each other, not from technique alone."
    ]
  },
  "dirty-talk": {
    icon: "💬", title: "Dirty Talk: How to Make It Hot (Not Cringe)",
    teaser: "Easy lines, timing, and how to find your style.",
    content: [
      "Dirty talk can feel awkward at first, but done right, it's one of the most powerful tools of seduction.",
      "Start Simple — You don't need to write a script. Start with describing what you're feeling.",
      "Read the Room — Pay attention to your partner's reactions. If they respond positively, keep going.",
      "Use Their Name — Nothing personalises the moment more than hearing your name whispered in the heat of things.",
      "Timing Matters — Build anticipation. A well-placed whisper before things even start can set the entire mood.",
      "Be Authentic — The biggest turn-off is inauthenticity. Say what you genuinely feel.",
      "Pro tip: Start with texts before trying it in person. It's lower pressure and lets you find your voice."
    ]
  },
  "trends-2025": {
    icon: "⚡", title: "Sex & Dating Trends in 2025",
    teaser: "What people are doing more of — and what they're done with.",
    content: [
      "People are more direct about what they want, and less patient with games.",
      "Slow Dating — Quality over quantity is the new standard. People are tired of meaningless swiping.",
      "Ethical Non-Monogamy — More people are exploring open relationships with clear boundaries and communication.",
      "Digital Detox Dates — Phone-free dates are becoming a flex. Being present is the new romantic gesture.",
      "Consent Culture — Enthusiastic, ongoing consent isn't just expected — it's celebrated.",
      "Body Positivity — Platforms celebrating all body types are gaining traction. Authenticity is winning over filters.",
      "The biggest trend: clarity. If you're honest, you get better matches."
    ]
  },
  "first-meetup": {
    icon: "🥂", title: "First Meetup: How to Make It Safe & Sexy",
    teaser: "Meeting someone from an app for the first time? Here's how to keep it hot and safe.",
    content: [
      "Meeting someone new is exciting, but safety should always come first. Here's how to do both.",
      "Always Meet in Public First — A bar, coffee shop, or restaurant gives you an easy out if things don't click.",
      "Tell a Friend — Share your location and who you're meeting with someone you trust.",
      "Trust Your Gut — If something feels off, it probably is. You don't owe anyone your time.",
      "Keep It Light — Don't go in with massive expectations. The best connections happen naturally.",
      "Set Boundaries Early — Before you even get there, know what you're comfortable with and communicate it.",
      "Have Fun — If the vibe is right, let it flow. Chemistry can't be forced, but it can be encouraged.",
      "Follow Up — If you had a good time, say so. Ghosting is dead. Clarity is the new sexy."
    ]
  },
  "boundaries": {
    icon: "🛡️", title: "Setting Boundaries Without Killing the Vibe",
    teaser: "How to say what you need without making things awkward.",
    content: [
      "Boundaries aren't walls — they're invitations to treat each other well.",
      "Know Yours Before You Go — Think about what you want and don't want before you're in the moment.",
      "Use 'I' Statements — 'I'm not into that' is clearer and less confrontational than 'You shouldn't do that.'",
      "Timing Matters — Bring things up casually, not in the heat of the moment. Early is better than too late.",
      "It's Not a Mood Killer — Confidence in your boundaries is actually attractive. People respect clarity.",
      "Respect Goes Both Ways — If someone sets a boundary with you, honour it without questioning.",
      "Revisit as Needed — Boundaries can evolve. What felt right last time might not feel right now, and that's okay."
    ]
  },
  "swinger-etiquette": {
    icon: "🔄", title: "Swinger Etiquette: The Unwritten Rules",
    teaser: "New to the lifestyle? Here's what everyone wishes they knew from the start.",
    content: [
      "The swinger community runs on respect, communication, and consent. Here's what to know.",
      "Communicate With Your Partner First — Before you even enter the scene, both partners need to be fully on board and aligned.",
      "No Means No, Always — Just because someone is at a party doesn't mean they're available. Ask, don't assume.",
      "Hygiene Is Non-Negotiable — Show up clean, groomed, and respectful. First impressions matter.",
      "Don't Pressure Anyone — Let things happen naturally. Desperation is the biggest turn-off in any setting.",
      "Respect Couples' Rules — Every couple has their own boundaries. Some watch only, some participate. Ask.",
      "Discretion Is Everything — What happens in the lifestyle stays in the lifestyle. Never out anyone.",
      "Debrief After — Talk to your partner after every experience. Check in emotionally. This keeps your relationship strong."
    ]
  },
  "sexting-guide": {
    icon: "📱", title: "The Art of Sexting: A Modern Guide",
    teaser: "How to keep things hot over text without crossing lines.",
    content: [
      "Sexting is foreplay for the digital age. Done right, it builds anticipation like nothing else.",
      "Start Slow — Don't go from 'hey' to explicit in one message. Build up. Tease. Suggest.",
      "Match Their Energy — If they're sending one-word replies, don't send paragraphs. Read the room.",
      "Ask Before Sending Photos — Consent applies to sexting too. Always ask before sending anything explicit.",
      "Be Descriptive — Paint a picture. Tell them what you want to do, what you're thinking about.",
      "Keep It Private — Never share someone's private messages or photos. Ever. Full stop.",
      "Know When to Stop — If someone isn't reciprocating, back off. No one owes you a response.",
      "Save the Best for In Person — Leave something to the imagination. Anticipation is half the fun."
    ]
  },
  "communication-bedroom": {
    icon: "💬", title: "How to Talk About What You Want in Bed",
    teaser: "Most people want better sex but don't know how to ask for it.",
    content: [
      "Great sex starts with great communication. Here's how to have the conversation without it being awkward.",
      "Start Outside the Bedroom — Bring it up casually over dinner or drinks. Less pressure, more openness.",
      "Use Positive Framing — Instead of 'I don't like when you...', try 'I really love when you...'",
      "Be Specific — 'I want more foreplay' is better than 'I want things to be different.'",
      "Listen as Much as You Talk — This isn't a monologue. Ask what they want too.",
      "Don't Take It Personally — If your partner asks for something different, it's not criticism — it's trust.",
      "Try a Yes/No/Maybe List — Both partners list activities as yes, no, or maybe. Compare notes. No judgment.",
      "Check In During — A simple 'does that feel good?' goes a long way."
    ]
  },
  "online-safety": {
    icon: "🔐", title: "Staying Safe on Dating & Hook-up Sites",
    teaser: "Protect yourself online so you can enjoy yourself offline.",
    content: [
      "Online dating is powerful, but you need to protect yourself. Here's how.",
      "Verify Profiles — Look for verified badges. If something seems too good to be true, it probably is.",
      "Don't Share Personal Info Too Fast — Keep your surname, address, and workplace private until you trust someone.",
      "Video Call First — Before meeting in person, do a quick video call. It confirms they're real.",
      "Use the Platform's Messaging — Don't move to WhatsApp or personal number too quickly.",
      "Report Suspicious Behaviour — If someone pressures you, sends unsolicited content, or seems fake, report them.",
      "Trust Your Instincts — If a conversation makes you uncomfortable, you don't owe anyone an explanation.",
      "Tell Someone Where You're Going — Share your live location with a trusted friend when meeting someone new."
    ]
  }
};

// Mobile-optimized image compression - avoids memory issues on phones
const compressImage = (file, maxWidth = 800, quality = 0.7) => {
  return new Promise((resolve, reject) => {
    // Check file size - if small enough, just read it
    if (file.size < 100000) { // < 100KB, don't compress
      const reader = new FileReader();
      reader.onload = (e) => resolve(e.target.result);
      reader.onerror = () => reject(new Error('Failed to read file'));
      reader.readAsDataURL(file);
      return;
    }

    // For larger files, use createImageBitmap which is more memory efficient
    createImageBitmap(file)
      .then(bitmap => {
        let width = bitmap.width;
        let height = bitmap.height;
        
        // Scale down if larger than maxWidth
        if (width > maxWidth) {
          height = Math.round((height * maxWidth) / width);
          width = maxWidth;
        }
        
        // Use OffscreenCanvas if available (better memory management)
        let canvas;
        if (typeof OffscreenCanvas !== 'undefined') {
          canvas = new OffscreenCanvas(width, height);
        } else {
          canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
        }
        
        const ctx = canvas.getContext('2d');
        ctx.drawImage(bitmap, 0, 0, width, height);
        
        // Release bitmap memory immediately
        bitmap.close();
        
        // Convert to blob then to dataURL (more memory efficient)
        if (canvas.convertToBlob) {
          canvas.convertToBlob({ type: 'image/jpeg', quality })
            .then(blob => {
              const reader = new FileReader();
              reader.onload = () => resolve(reader.result);
              reader.onerror = () => reject(new Error('Failed to convert'));
              reader.readAsDataURL(blob);
            })
            .catch(reject);
        } else {
          // Fallback for regular canvas
          resolve(canvas.toDataURL('image/jpeg', quality));
        }
      })
      .catch(() => {
        // Fallback: traditional approach for browsers without createImageBitmap
        const reader = new FileReader();
        reader.onerror = () => reject(new Error('Failed to read file'));
        reader.onload = (e) => {
          const img = new Image();
          img.onerror = () => reject(new Error('Failed to load image'));
          img.onload = () => {
            let width = img.width;
            let height = img.height;
            if (width > maxWidth) {
              height = Math.round((height * maxWidth) / width);
              width = maxWidth;
            }
            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);
            resolve(canvas.toDataURL('image/jpeg', quality));
          };
          img.src = e.target.result;
        };
        reader.readAsDataURL(file);
      });
  });
};

const AuthContext = createContext(null);
const useAuth = () => useContext(AuthContext);

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [loading, setLoading] = useState(true);
  const [config, setConfig] = useState(null);

  useEffect(() => {
    const init = async () => {
      // Load config in the background (do not block auth / page render)
      axios.get(`${API}/config/all`)
        .then((configRes) => {
          setConfig(configRes.data);
          console.log('Config loaded:', configRes.data);
        })
        .catch((e) => {
          console.error('Config load error:', e.message);
        });
      
      if (token) {
        try {
          const res = await axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } });
          setUser(res.data);
        } catch (e) {
          localStorage.removeItem("token");
          setToken(null);
        }
      }
      setLoading(false);
    };
    init();
  }, [token]);

  const login = async (email, password) => {
    const res = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem("token", res.data.access_token);
    setToken(res.data.access_token);
    setUser(res.data.user);
    return res.data;
  };

  const signup = async (userData) => {
    const res = await axios.post(`${API}/auth/signup`, userData);
    localStorage.setItem("token", res.data.access_token);
    setToken(res.data.access_token);
    setUser(res.data.user);
    return res.data;
  };

  const logout = async () => {
    try { await axios.post(`${API}/auth/logout`, {}, { headers: { Authorization: `Bearer ${token}` } }); } catch (e) { console.log('Logout:', e.message); }
    localStorage.removeItem("token");
    setToken(null);
    setUser(null);
  };

  const refreshUser = async () => {
    if (token) {
      const res = await axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } });
      setUser(res.data);
    }
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, config, login, signup, logout, setUser, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading-screen"><div className="spinner"></div></div>;
  if (!user) return <Navigate to="/login" />;
  return children;
};

// Crop Modal with pan + zoom
const CropModal = ({ imageSrc, onComplete, onCancel }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const onCropComplete = useCallback((_, px) => setCroppedAreaPixels(px), []);
  const handleDone = async () => {
    if (!croppedAreaPixels) return;
    const img = new Image(); img.crossOrigin = 'anonymous'; img.src = imageSrc;
    await new Promise(r => { img.onload = r; });
    const c = document.createElement('canvas'); c.width = croppedAreaPixels.width; c.height = croppedAreaPixels.height;
    c.getContext('2d').drawImage(img, croppedAreaPixels.x, croppedAreaPixels.y, croppedAreaPixels.width, croppedAreaPixels.height, 0, 0, croppedAreaPixels.width, croppedAreaPixels.height);
    onComplete(c.toDataURL('image/jpeg', 0.85));
  };
  return (
    <div className="crop-modal-overlay" data-testid="crop-modal">
      <div className="crop-modal-content">
        <h3>Crop Photo</h3>
        <p style={{color:'#999',fontSize:13,marginBottom:8}}>Drag to move, scroll to zoom</p>
        <div className="crop-container">
          <Cropper image={imageSrc} crop={crop} zoom={zoom} aspect={1} onCropChange={setCrop} onZoomChange={setZoom} onCropComplete={onCropComplete} cropShape="round" showGrid={false} />
        </div>
        <div className="crop-controls"><label>Zoom</label><input type="range" min={1} max={3} step={0.05} value={zoom} onChange={e => setZoom(Number(e.target.value))} /></div>
        <div className="crop-actions"><button className="btn-cancel" onClick={onCancel}>Cancel</button><button className="btn-primary" onClick={handleDone}>Done</button></div>
      </div>
    </div>
  );
};

// Navigation with Alerts
const Nav = () => {
  const { user, logout, token } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [alerts, setAlerts] = useState([]);
  const [showAlerts, setShowAlerts] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const tierColors = { silver: '#A8A8A8', gold: '#FFD700', platinum: '#E8E8E8' };

  useEffect(() => {
    const fetchAlerts = async () => {
      try {
        const res = await axios.get(`${API}/notifications`, { headers: { Authorization: `Bearer ${token}` } });
        setAlerts(res.data.notifications || []);
        setUnreadCount(res.data.unread_count || 0);
      } catch (e) { console.log('Alerts:', e.message); }
    };
    if (token) fetchAlerts();
  }, [token]);

  const markRead = async (id) => {
    try {
      await axios.post(`${API}/notifications/${id}/read`, {}, { headers: { Authorization: `Bearer ${token}` } });
      setAlerts(a => a.map(n => n.id === id ? { ...n, read: true } : n));
      setUnreadCount(c => Math.max(0, c - 1));
    } catch (e) { console.log(e); }
  };

  const isActive = (p) => location.pathname === p;

  // Close alerts when clicking outside
  useEffect(() => {
    const close = (e) => { if (showAlerts && !e.target.closest('.nav-alerts')) setShowAlerts(false); };
    document.addEventListener('click', close);
    return () => document.removeEventListener('click', close);
  }, [showAlerts]);
  
  return (
    <>
      <nav className="main-nav" data-testid="main-nav">
        <div className="nav-brand" onClick={() => navigate('/home')}>FWB SA</div>
        <div className="nav-links desktop-nav">
          <button className={isActive('/home') ? 'active' : ''} onClick={() => navigate('/home')}>Home</button>
          <button className={isActive('/meet') ? 'active' : ''} onClick={() => navigate('/meet')}>Meet</button>
          <button className={isActive('/socials') ? 'active' : ''} onClick={() => navigate('/socials')}>Socials</button>
          <button className={isActive('/media') ? 'active' : ''} onClick={() => navigate('/media')}>Media</button>
          <button className={isActive('/forum') ? 'active' : ''} onClick={() => navigate('/forum')}>Forum</button>
          <button className={isActive('/inbox') ? 'active' : ''} onClick={() => navigate('/inbox')}>Inbox</button>
          {(user?.email === 'admin@fwbsa.co.za' || user?.role === 'owner' || user?.role === 'admin') && <button className="nav-admin" onClick={() => navigate('/dashboard')}>Admin</button>}
        </div>
        <div className="nav-right">
          <div className="nav-alerts" onClick={() => setShowAlerts(!showAlerts)}>
            <span className="bell-icon">🔔</span>
            {unreadCount > 0 && <span className="alert-badge">{unreadCount}</span>}
            {showAlerts && (
              <div className="alerts-dropdown" onClick={e => e.stopPropagation()}>
                <div className="alerts-header">
                  <h4>Notifications</h4>
                  {alerts.filter(n => !n.read).length > 0 && <span className="mark-all" onClick={() => { setAlerts(a => a.map(n => ({...n, read: true}))); setUnreadCount(0); }}>Mark all read</span>}
                </div>
                <div className="alerts-list">
                  {alerts.length === 0 ? <p className="no-alerts">No notifications yet</p> : alerts.slice(0, 10).map(n => (
                    <div key={n.id} className={`alert-item ${!n.read ? 'unread' : ''}`} onClick={() => { markRead(n.id); if(n.link) navigate(n.link); setShowAlerts(false); }}>
                      <span className="alert-icon">{n.type === 'like' ? '❤️' : n.type === 'view' ? '👁️' : n.type === 'match' ? '🎉' : n.type === 'message' ? '💬' : '🔔'}</span>
                      <div className="alert-content">
                        <p>{n.message}</p>
                        <small>{n.time_ago || 'Just now'}</small>
                      </div>
                    </div>
                  ))}
                </div>
                {alerts.length > 0 && <div className="alerts-footer" onClick={() => { navigate('/notifications'); setShowAlerts(false); }}>See all notifications</div>}
              </div>
            )}
          </div>
          <div className="nav-coins desktop-nav" onClick={() => navigate('/store')}>🪙 {user?.coins || 0}</div>
          <div className="nav-tier desktop-nav" style={{ color: tierColors[user?.membership_tier] }} onClick={() => navigate('/membership')}>
            {user?.membership_tier?.toUpperCase()}
          </div>
          <div className="nav-avatar" onClick={() => navigate('/profile')}>
            {user?.profile_photo ? <img src={user.profile_photo} alt="" /> : user?.name?.charAt(0)}
          </div>
          <button className="nav-settings desktop-nav" onClick={(e) => { e.stopPropagation(); navigate('/settings'); }}>⚙️</button>
          <button className="nav-logout desktop-nav" onClick={logout}>Logout</button>
        </div>
      </nav>
      <div className="mobile-toolbar" data-testid="mobile-toolbar">
        <button className={isActive('/home') ? 'active' : ''} onClick={() => navigate('/home')}><span className="tb-icon">🏠</span><span className="tb-label">Home</span></button>
        <button className={isActive('/meet') ? 'active' : ''} onClick={() => navigate('/meet')}><span className="tb-icon">🔥</span><span className="tb-label">Meet</span></button>
        <button className={isActive('/socials') ? 'active' : ''} onClick={() => navigate('/socials')}><span className="tb-icon">💋</span><span className="tb-label">Social</span></button>
        <button className={isActive('/inbox') ? 'active' : ''} onClick={() => navigate('/inbox')}><span className="tb-icon">💬</span><span className="tb-label">Inbox</span></button>
        <button className={isActive('/profile') ? 'active' : ''} onClick={() => navigate('/profile')}><span className="tb-icon">👤</span><span className="tb-label">Me</span></button>
        <button onClick={() => navigate('/settings')}><span className="tb-icon">⚙️</span><span className="tb-label">More</span></button>
      </div>
    </>
  );
};

// COMING SOON LANDING PAGE
const ComingSoonPage = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showLegal, setShowLegal] = useState(null);
  const navigate = useNavigate();

  const handleNotify = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await axios.post(`${API}/subscribe`, { email });
      setSubmitted(true);
    } catch (err) {
      if (err.response?.data?.already_subscribed) {
        setSubmitted(true);
      } else {
        setError('Something went wrong. Please try again.');
      }
    }
    setLoading(false);
  };

  const tiers = [
    {
      name: 'Silver',
      price: 'FREE',
      color: '#A8A8A8',
      features: [
        'Limited daily swipes',
        'Limited super likes',
        'Basic messaging',
        '1 boost per week',
        '10 winks per week',
        'Browse members (blurred)',
      ],
    },
    {
      name: 'Gold',
      price: 'R249',
      color: '#FFD700',
      popular: true,
      features: [
        'Increased daily swipes',
        'More super likes',
        'Extended messaging',
        'View clear profiles',
        'See who viewed you',
        'Priority support'
      ],
    },
    {
      name: 'Platinum',
      price: 'R399',
      color: '#E8E8E8',
      features: [
        'UNLIMITED swipes',
        '5 super likes per week',
        'UNLIMITED messages',
        '5 boosts per week',
        'UNLIMITED winks',
        'Full profile access',
        'Post & respond to meetups',
        'Priority VIP support',
        'Incognito mode',
      ],
    },
  ];

  return (
    <div className="coming-soon-page">
      <div className="cs-bg" style={{ backgroundImage: `url(${BG_WOMAN})` }}></div>
      <div className="cs-overlay"></div>
      
      <div className="cs-content">
        {/* Header */}
        <div className="cs-header">
          <h1 className="cs-brand">FWB SA</h1>
          <div className="cs-header-right">
            <span className="cs-member-link" onClick={() => navigate('/login')}>•</span>
            <div className="cs-badge">COMING SOON</div>
          </div>
        </div>

        {/* Hero */}
        <div className="cs-hero">
          <h2>No Games. <span>Just Heat.</span></h2>
          <p className="cs-tagline">
            South Africa's premier adult dating platform for swingers, couples & singles seeking 
            real connections. Verified profiles. Discreet encounters. Zero fakes.
          </p>
        </div>

        {/* About Section */}
        <div className="cs-about">
          <h3>What is FWB SA?</h3>
          <p>
            FWB SA is an exclusive members-only platform designed for open-minded adults in South Africa 
            who are looking to connect with like-minded individuals and couples. Whether you're exploring 
            the lifestyle, seeking casual encounters, or looking for that special connection without the 
            complications of traditional dating, FWB SA provides a safe, private, and judgment-free space.
          </p>
          <div className="cs-about-points">
            <div className="cs-point">
              <span>✓</span>
              <p><strong>For Singles & Couples</strong> — Connect with individuals or pairs who share your interests and desires</p>
            </div>
            <div className="cs-point">
              <span>✓</span>
              <p><strong>Lifestyle Friendly</strong> — A welcoming community for swingers and those curious about the lifestyle</p>
            </div>
            <div className="cs-point">
              <span>✓</span>
              <p><strong>100% Discreet</strong> — Your privacy is our priority. Browse anonymously with incognito mode</p>
            </div>
            <div className="cs-point">
              <span>✓</span>
              <p><strong>Verified Members</strong> — Real profiles, real people. No bots, no fakes, no time wasters</p>
            </div>
            <div className="cs-point">
              <span>✓</span>
              <p><strong>Local Connections</strong> — Meet people in your area with our location-based matching</p>
            </div>
            <div className="cs-point">
              <span>✓</span>
              <p><strong>Events & Meetups</strong> — Join or host private parties and social gatherings</p>
            </div>
          </div>
        </div>

        {/* Features */}
        <div className="cs-features">
          <div className="cs-feature">
            <span>🔥</span>
            <h4>Swingers Welcome</h4>
            <p>Explore your wild side</p>
          </div>
          <div className="cs-feature">
            <span>💎</span>
            <h4>Professional & Discreet</h4>
            <p>Elite members only</p>
          </div>
          <div className="cs-feature">
            <span>🛡️</span>
            <h4>Verified Profiles</h4>
            <p>Real people, no fakes</p>
          </div>
          <div className="cs-feature">
            <span>⚡</span>
            <h4>Instant Meetups</h4>
            <p>Connect today</p>
          </div>
        </div>

        {/* Membership Tiers */}
        <div className="cs-tiers-section">
          <h3>Membership Plans</h3>
          <div className="cs-tiers">
            {tiers.map((tier) => (
              <div key={tier.name} className={`cs-tier ${tier.popular ? 'popular' : ''}`}>
                {tier.popular && <div className="cs-popular-tag">MOST POPULAR</div>}
                <div className="cs-tier-header" style={{ background: `linear-gradient(135deg, ${tier.color}, ${tier.color}88)` }}>
                  <h4>{tier.name}</h4>
                  <div className="cs-price">{tier.price}{tier.price !== 'FREE' && <span>/mo</span>}</div>
                </div>
                <ul className="cs-tier-features">
                  {tier.features.map((f, i) => (
                    <li key={i}>✓ {f}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Notify Form */}
        <div className="cs-notify">
          <h3>Get Notified When We Launch</h3>
          {!submitted ? (
            <form onSubmit={handleNotify} className="cs-form">
              <input 
                type="email" 
                placeholder="Enter your email" 
                value={email} 
                onChange={(e) => setEmail(e.target.value)} 
                required 
              />
              <button type="submit" disabled={loading}>{loading ? 'Subscribing...' : 'Notify Me'}</button>
              {error && <p className="cs-error">{error}</p>}
            </form>
          ) : (
            <div className="cs-success">
              <span>✓</span> Thanks! We'll notify you when we launch.
            </div>
          )}
        </div>

        {/* Footer with Legal Links */}
        <div className="cs-footer">
          <div className="cs-legal-links">
            <button onClick={() => setShowLegal('terms')}>Terms & Conditions</button>
            <span>|</span>
            <button onClick={() => setShowLegal('privacy')}>Privacy Policy</button>
            <span>|</span>
            <button onClick={() => setShowLegal('popi')}>POPIA Compliance</button>
            <span>|</span>
            <button onClick={() => setShowLegal('refund')}>Refund Policy</button>
            <span>|</span>
            <button onClick={() => setShowLegal('cookies')}>Cookie Policy</button>
            <span>|</span>
            <button onClick={() => setShowLegal('community')}>Community Guidelines</button>
          </div>
          <p>© 2024 FWB SA. Adults 18+ only. All rights reserved.</p>
          <p className="cs-domain">www.fwbsa.co.za</p>
        </div>
      </div>

      {/* Legal Modals */}
      {showLegal && (
        <div className="legal-modal" onClick={() => setShowLegal(null)}>
          <div className="legal-content" onClick={e => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setShowLegal(null)}>✕</button>
            {showLegal === 'terms' && <LegalTermsCS />}
            {showLegal === 'privacy' && <LegalPrivacyCS />}
            {showLegal === 'popi' && <LegalPOPICS />}
            {showLegal === 'refund' && <LegalRefundCS />}
            {showLegal === 'cookies' && <LegalCookiesCS />}
            {showLegal === 'community' && <LegalCommunityCS />}
          </div>
        </div>
      )}
    </div>
  );
};

// Legal Document Components for Coming Soon Page
const LegalTermsCS = () => (
  <div className="legal-doc">
    <h2>Terms & Conditions</h2>
    <p className="legal-updated">Last updated: December 2024</p>
    
    <h3>1. Acceptance of Terms</h3>
    <p>By accessing and using FWB SA ("the Platform"), you agree to be bound by these Terms & Conditions ("Terms"). If you do not agree to these Terms, you must not use our services. These Terms constitute a legally binding agreement between you and FWB SA (Pty) Ltd.</p>
    
    <h3>2. Eligibility</h3>
    <p>You must be at least 18 years of age to use FWB SA. By registering, you confirm that you are legally an adult in South Africa. We reserve the right to request proof of age at any time and to terminate accounts that violate this requirement.</p>
    
    <h3>3. Account Registration</h3>
    <p>You agree to provide accurate, current, and complete information during registration. You are responsible for maintaining the confidentiality of your account credentials and for all activities under your account. You must notify us immediately of any unauthorized use.</p>
    
    <h3>4. Membership & Payments</h3>
    <p>FWB SA offers free (Silver) and paid (Gold, Platinum) membership tiers. Paid memberships are billed monthly unless otherwise stated. By purchasing a membership, you authorize us to charge your selected payment method. All prices are in South African Rand (ZAR) and include VAT where applicable.</p>
    
    <h3>5. User Conduct</h3>
    <p>You agree NOT to:</p>
    <ul>
      <li>Harass, abuse, threaten, or intimidate other users</li>
      <li>Post illegal content or content involving minors</li>
      <li>Impersonate any person or entity</li>
      <li>Use automated systems, bots, or scripts</li>
      <li>Attempt to hack, reverse-engineer, or disrupt the Platform</li>
      <li>Solicit money from other users</li>
      <li>Use the Platform for commercial purposes without authorization</li>
      <li>Violate any applicable South African laws</li>
    </ul>
    
    <h3>6. Content Ownership</h3>
    <p>You retain ownership of content you post but grant FWB SA a non-exclusive, royalty-free, worldwide license to use, display, reproduce, and distribute such content on our Platform for the purpose of operating our services.</p>
    
    <h3>7. Profile Verification</h3>
    <p>We may require profile verification to ensure authenticity. Providing false information during verification will result in immediate account termination without refund.</p>
    
    <h3>8. Termination</h3>
    <p>We reserve the right to suspend or terminate your account at any time, with or without notice, for violations of these Terms or for any other reason at our sole discretion. Upon termination, your right to use the Platform ceases immediately.</p>
    
    <h3>9. Disclaimer of Warranties</h3>
    <p>FWB SA is provided "as is" and "as available" without warranties of any kind, either express or implied. We do not warrant that the service will be uninterrupted, secure, or error-free. We are not responsible for the conduct of users online or offline.</p>
    
    <h3>10. Limitation of Liability</h3>
    <p>To the maximum extent permitted by South African law, FWB SA shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of or inability to use our services.</p>
    
    <h3>11. Governing Law</h3>
    <p>These Terms are governed by the laws of the Republic of South Africa. Any disputes shall be subject to the exclusive jurisdiction of the South African courts.</p>
    
    <h3>12. Changes to Terms</h3>
    <p>We may modify these Terms at any time. Continued use of the Platform after changes constitutes acceptance of the modified Terms. Material changes will be communicated via email or Platform notification.</p>
    
    <h3>13. Contact</h3>
    <p>For questions about these Terms, contact us at: legal@fwbsa.co.za</p>
  </div>
);

const LegalPrivacyCS = () => (
  <div className="legal-doc">
    <h2>Privacy Policy</h2>
    <p className="legal-updated">Last updated: December 2024</p>
    
    <h3>1. Introduction</h3>
    <p>FWB SA (Pty) Ltd ("we", "us", "our") is committed to protecting your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our platform.</p>
    
    <h3>2. Information We Collect</h3>
    <p><strong>Information you provide directly:</strong></p>
    <ul>
      <li>Account information: name, email, date of birth, gender, location</li>
      <li>Profile information: photos, bio, preferences, interests</li>
      <li>Payment information: processed securely through third-party providers</li>
      <li>Communications: messages sent through the platform</li>
      <li>Verification data: photos or videos for identity verification</li>
    </ul>
    <p><strong>Information collected automatically:</strong></p>
    <ul>
      <li>Device information: IP address, browser type, operating system</li>
      <li>Usage data: pages visited, features used, time spent</li>
      <li>Location data: approximate location based on IP or GPS (with permission)</li>
      <li>Cookies and similar technologies</li>
    </ul>
    
    <h3>3. How We Use Your Information</h3>
    <ul>
      <li>To provide and improve our services</li>
      <li>To match you with other compatible users</li>
      <li>To communicate with you about your account and updates</li>
      <li>To process payments and prevent fraud</li>
      <li>To ensure safety and security on our platform</li>
      <li>To comply with legal obligations</li>
      <li>To send marketing communications (with your consent)</li>
    </ul>
    
    <h3>4. Information Sharing</h3>
    <p>We do NOT sell your personal information. We may share information with:</p>
    <ul>
      <li>Other users: Only profile information you choose to make visible</li>
      <li>Service providers: Who assist in operating our platform</li>
      <li>Legal authorities: When required by law or to protect rights</li>
      <li>Business transfers: In case of merger, acquisition, or sale</li>
    </ul>
    
    <h3>5. Data Security</h3>
    <p>We implement appropriate technical and organizational security measures to protect your personal information, including encryption, secure servers, and access controls. However, no method of transmission over the Internet is 100% secure.</p>
    
    <h3>6. Data Retention</h3>
    <p>We retain your personal information for as long as your account is active or as needed to provide services. After account deletion, we may retain certain information for legal compliance, dispute resolution, or fraud prevention for up to 7 years.</p>
    
    <h3>7. Your Rights</h3>
    <p>Under South African law (including POPIA), you have the right to:</p>
    <ul>
      <li>Access your personal information</li>
      <li>Correct inaccurate information</li>
      <li>Request deletion of your information</li>
      <li>Object to certain processing</li>
      <li>Data portability</li>
      <li>Withdraw consent</li>
    </ul>
    
    <h3>8. International Transfers</h3>
    <p>Your information may be transferred to and processed in countries other than South Africa. We ensure appropriate safeguards are in place for such transfers.</p>
    
    <h3>9. Children's Privacy</h3>
    <p>FWB SA is strictly for adults 18 years and older. We do not knowingly collect information from anyone under 18.</p>
    
    <h3>10. Contact Us</h3>
    <p>For privacy-related inquiries or to exercise your rights:<br/>
    Email: privacy@fwbsa.co.za<br/>
    Information Officer: info@fwbsa.co.za</p>
  </div>
);

const LegalPOPICS = () => (
  <div className="legal-doc">
    <h2>POPIA Compliance Statement</h2>
    <p className="legal-updated">Protection of Personal Information Act (Act 4 of 2013)</p>
    
    <h3>Our Commitment</h3>
    <p>FWB SA (Pty) Ltd is fully committed to complying with the Protection of Personal Information Act (POPIA) of South Africa. We process personal information lawfully, in a reasonable manner that does not infringe on your privacy.</p>
    
    <h3>Responsible Party</h3>
    <p>FWB SA (Pty) Ltd is the responsible party for the processing of your personal information as defined under POPIA.</p>
    
    <h3>Information Officer</h3>
    <p>Our designated Information Officer is responsible for ensuring POPIA compliance and handling all information-related requests.</p>
    <p>Contact: info@fwbsa.co.za</p>
    
    <h3>Lawful Basis for Processing</h3>
    <p>We process your personal information based on:</p>
    <ul>
      <li><strong>Consent:</strong> You have given clear consent for processing</li>
      <li><strong>Contract:</strong> Processing is necessary to fulfill our service agreement</li>
      <li><strong>Legal obligation:</strong> Processing is required by South African law</li>
      <li><strong>Legitimate interest:</strong> Processing is in our legitimate business interests</li>
    </ul>
    
    <h3>Your Rights Under POPIA</h3>
    <p>As a data subject, you have the following rights:</p>
    <ul>
      <li><strong>Right to be notified:</strong> That your personal information is being collected</li>
      <li><strong>Right to access:</strong> Request a copy of your personal information</li>
      <li><strong>Right to correction:</strong> Request correction of inaccurate information</li>
      <li><strong>Right to deletion:</strong> Request deletion of your personal information</li>
      <li><strong>Right to object:</strong> Object to processing of your personal information</li>
      <li><strong>Right not to be subject to automated decisions:</strong> That significantly affect you</li>
      <li><strong>Right to complain:</strong> Lodge a complaint with the Information Regulator</li>
    </ul>
    
    <h3>How to Exercise Your Rights</h3>
    <p>To exercise any of your rights, please contact our Information Officer at info@fwbsa.co.za. We will respond to your request within 30 days as required by POPIA.</p>
    
    <h3>Security Safeguards</h3>
    <p>We have implemented appropriate technical and organizational measures to secure your personal information, including:</p>
    <ul>
      <li>Encryption of data in transit and at rest</li>
      <li>Access controls and authentication</li>
      <li>Regular security assessments</li>
      <li>Employee training on data protection</li>
    </ul>
    
    <h3>Data Breach Notification</h3>
    <p>In the event of a data breach that poses a risk to your rights, we will notify you and the Information Regulator as soon as reasonably possible.</p>
    
    <h3>Information Regulator</h3>
    <p>If you are not satisfied with how we handle your personal information, you may lodge a complaint with:</p>
    <p>The Information Regulator (South Africa)<br/>
    Website: www.justice.gov.za/inforeg<br/>
    Email: inforeg@justice.gov.za</p>
  </div>
);

const LegalRefundCS = () => (
  <div className="legal-doc">
    <h2>Cancellation & Refund Policy</h2>
    <p className="legal-updated">Last updated: December 2024</p>
    
    <h3>1. Subscription Cancellation</h3>
    <p>You may cancel your paid subscription at any time through your account settings. Upon cancellation:</p>
    <ul>
      <li>Your subscription will remain active until the end of the current billing period</li>
      <li>You will not be charged for the next billing cycle</li>
      <li>Your account will revert to a free Silver membership after expiry</li>
      <li>You will retain access to your profile, matches, and messages</li>
    </ul>
    
    <h3>2. Cooling-Off Period</h3>
    <p>In accordance with the Consumer Protection Act (CPA) of South Africa, you have the right to cancel your subscription within 5 business days of purchase ("cooling-off period") for a full refund, provided you have not used any premium features.</p>
    
    <h3>3. Refund Eligibility</h3>
    <p><strong>Full refunds may be granted for:</strong></p>
    <ul>
      <li>Cancellation within the 5-day cooling-off period (unused premium features)</li>
      <li>Duplicate charges or billing errors</li>
      <li>Service unavailability exceeding 7 consecutive days</li>
      <li>Account termination by FWB SA without cause</li>
    </ul>
    
    <p><strong>Refunds will NOT be granted for:</strong></p>
    <ul>
      <li>Cancellation after the cooling-off period</li>
      <li>Account termination due to Terms violation</li>
      <li>Failure to find matches or connections</li>
      <li>Dissatisfaction with other users</li>
      <li>Partial month usage</li>
      <li>Coin purchases (virtual currency) - all coin sales are final</li>
    </ul>
    
    <h3>4. How to Request a Refund</h3>
    <p>To request a refund:</p>
    <ol>
      <li>Email billing@fwbsa.co.za with subject "Refund Request"</li>
      <li>Include your registered email address</li>
      <li>Provide reason for refund request</li>
      <li>Include proof of purchase if available</li>
    </ol>
    
    <h3>5. Refund Processing</h3>
    <p>Approved refunds will be processed within 7-14 business days to the original payment method. The time for funds to appear depends on your financial institution.</p>
    
    <h3>6. Pro-Rata Refunds</h3>
    <p>Pro-rata refunds are not offered. If you cancel mid-cycle, you retain access until the end of your paid period.</p>
    
    <h3>7. Subscription Modifications</h3>
    <p>Downgrading from Platinum to Gold or from paid to free:</p>
    <ul>
      <li>Takes effect at the end of the current billing period</li>
      <li>No partial refund for the current period</li>
      <li>Premium features will be disabled upon downgrade</li>
    </ul>
    
    <h3>8. Chargebacks</h3>
    <p>Filing a chargeback without first contacting us may result in account suspension. Please contact our billing team first to resolve any payment disputes.</p>
    
    <h3>9. Contact</h3>
    <p>Billing inquiries: billing@fwbsa.co.za<br/>
    General support: support@fwbsa.co.za</p>
  </div>
);

const LegalCookiesCS = () => (
  <div className="legal-doc">
    <h2>Cookie Policy</h2>
    <p className="legal-updated">Last updated: December 2024</p>
    
    <h3>1. What Are Cookies?</h3>
    <p>Cookies are small text files stored on your device when you visit our website. They help us provide you with a better experience by remembering your preferences and understanding how you use our platform.</p>
    
    <h3>2. Types of Cookies We Use</h3>
    
    <p><strong>Essential Cookies</strong></p>
    <p>Required for the platform to function. They enable core features like security, account access, and preferences. Cannot be disabled.</p>
    
    <p><strong>Performance Cookies</strong></p>
    <p>Help us understand how visitors interact with our platform by collecting anonymous information about page visits, load times, and errors.</p>
    
    <p><strong>Functionality Cookies</strong></p>
    <p>Remember your choices and preferences (like login status, language, location) to provide enhanced features.</p>
    
    <p><strong>Targeting/Advertising Cookies</strong></p>
    <p>Used to deliver relevant advertisements and track the effectiveness of marketing campaigns. You can opt out of these.</p>
    
    <h3>3. Third-Party Cookies</h3>
    <p>We may use third-party services that set their own cookies:</p>
    <ul>
      <li>Google Analytics - for usage statistics</li>
      <li>Payment processors - for secure transactions</li>
      <li>Social media platforms - if you use social login</li>
    </ul>
    
    <h3>4. Managing Cookies</h3>
    <p>You can control cookies through your browser settings:</p>
    <ul>
      <li>Block all cookies</li>
      <li>Delete existing cookies</li>
      <li>Allow cookies from specific sites</li>
      <li>Set preferences for different types of cookies</li>
    </ul>
    <p>Note: Blocking essential cookies may affect platform functionality.</p>
    
    <h3>5. Cookie Consent</h3>
    <p>By continuing to use FWB SA, you consent to our use of cookies as described in this policy. You can withdraw consent at any time by adjusting your browser settings.</p>
    
    <h3>6. Updates to This Policy</h3>
    <p>We may update this Cookie Policy periodically. Changes will be posted on this page with an updated revision date.</p>
    
    <h3>7. Contact</h3>
    <p>Questions about cookies? Contact: privacy@fwbsa.co.za</p>
  </div>
);

const LegalCommunityCS = () => (
  <div className="legal-doc">
    <h2>Community Guidelines</h2>
    <p className="legal-updated">Creating a safe, respectful community for all members</p>
    
    <h3>Our Values</h3>
    <p>FWB SA is built on respect, consent, and mutual enjoyment. These guidelines ensure everyone has a positive experience.</p>
    
    <h3>1. Respect Others</h3>
    <ul>
      <li>Treat all members with dignity and respect</li>
      <li>No harassment, bullying, or intimidation</li>
      <li>No hate speech, racism, sexism, or discrimination</li>
      <li>Accept rejection gracefully - not everyone will be interested</li>
      <li>Do not pressure anyone into anything</li>
    </ul>
    
    <h3>2. Consent is Everything</h3>
    <ul>
      <li>Always obtain clear, enthusiastic consent</li>
      <li>"No" means no. Respect boundaries immediately</li>
      <li>Consent can be withdrawn at any time</li>
      <li>Never share intimate content without explicit permission</li>
      <li>Do not screenshot or share private conversations</li>
    </ul>
    
    <h3>3. Be Honest</h3>
    <ul>
      <li>Use recent, accurate photos of yourself</li>
      <li>Be truthful about your age, relationship status, and intentions</li>
      <li>Don't create fake profiles or impersonate others</li>
      <li>Be upfront about what you're looking for</li>
    </ul>
    
    <h3>4. Keep It Legal</h3>
    <ul>
      <li>All users must be 18+ years old</li>
      <li>No solicitation or commercial services</li>
      <li>No illegal activities or substances</li>
      <li>No content involving minors - zero tolerance</li>
      <li>Comply with all South African laws</li>
    </ul>
    
    <h3>5. Protect Your Privacy & Safety</h3>
    <ul>
      <li>Don't share personal information (address, workplace) too quickly</li>
      <li>Meet in public places first</li>
      <li>Tell someone where you're going and who you're meeting</li>
      <li>Trust your instincts - if something feels wrong, leave</li>
      <li>Use the block feature for anyone who makes you uncomfortable</li>
    </ul>
    
    <h3>6. Report Violations</h3>
    <p>If you encounter inappropriate behavior:</p>
    <ul>
      <li>Use the Report button on profiles or messages</li>
      <li>Block the user immediately</li>
      <li>Email: safety@fwbsa.co.za for serious concerns</li>
      <li>Contact local authorities if you feel threatened</li>
    </ul>
    
    <h3>7. Consequences</h3>
    <p>Violations may result in:</p>
    <ul>
      <li>Warning or temporary suspension</li>
      <li>Permanent account ban without refund</li>
      <li>Reporting to law enforcement if applicable</li>
    </ul>
    
    <h3>Remember</h3>
    <p>Behind every profile is a real person. Treat others as you'd like to be treated. Let's keep FWB SA a fun, safe, and respectful space for everyone.</p>
  </div>
);

// LOGIN/SIGNUP PAGE - Updated for launch
const AuthPage = () => {
  const [mode, setMode] = useState('landing');
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [resetEmail, setResetEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const { login, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => { if (user) navigate("/home"); }, [user, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/home");
    } catch (e) {
      setError(e.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email: resetEmail });
      setSuccess("Password reset link sent to your email!");
    } catch (e) {
      setError(e.response?.data?.detail || "Failed to send reset email");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page launch-mode">
      <div className="auth-bg" style={{ backgroundImage: `url(${BG_WOMAN})` }}></div>
      <div className="auth-bg-overlay"></div>
      <div className="auth-content">
        {mode === 'landing' && (
          <>
            <div className="auth-brand">FWB SA</div>
            <h1 className="auth-title">No Games.</h1>
            <h1 className="auth-title accent">Just Heat.</h1>
            <p className="auth-desc">South Africa's premier adults-only (18+) platform for swingers, hookups & discreet connections. Real verified profiles. Safe connections and meetups.</p>
            
            <div className="trust-markers">
              <span>✓ No Bots</span>
              <span>✓ Real Profiles</span>
              <span>✓ 18+ Only</span>
              <span>✓ Discreet</span>
            </div>
            
            <div className="early-access-banner">
              <span>🎉</span>
              <p><strong>Early Access:</strong> First 200 members get Gold FREE!</p>
            </div>
            
            <div className="auth-btns">
              <button className="btn-get-started" onClick={() => navigate("/signup")}>Join Early Access</button>
              <button className="btn-login" onClick={() => setMode('login')}>Log In</button>
            </div>
            
            <div className="auth-footer-links">
              <span onClick={() => setShowTerms('terms')}>Terms</span>
              <span onClick={() => setShowTerms('privacy')}>Privacy</span>
              <span onClick={() => setShowTerms('cookies')}>Cookies</span>
            </div>
            <p className="auth-disclaimer">18+ only. By continuing, you agree to our Terms & Privacy Policy.</p>
          </>
        )}
        
        {mode === 'login' && (
          <div className="auth-form">
            <h2>Welcome Back</h2>
            {error && <div className="auth-error">{error}</div>}
            <form onSubmit={handleLogin}>
              <input type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} required />
              <input type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} required />
              <button type="submit" disabled={loading}>{loading ? "Signing in..." : "Sign In"}</button>
            </form>
            <p className="forgot-link" onClick={() => setMode('forgot')}>Forgot Password?</p>
            <p className="auth-switch">Don&apos;t have an account? <span onClick={() => navigate("/signup")}>Sign up</span></p>
            <p className="auth-back" onClick={() => setMode('landing')}>← Back</p>
          </div>
        )}

        {mode === 'forgot' && (
          <div className="auth-form">
            <h2>Reset Password</h2>
            {error && <div className="auth-error">{error}</div>}
            {success && <div className="auth-success">{success}</div>}
            <form onSubmit={handleForgotPassword}>
              <input type="email" placeholder="Enter your email" value={resetEmail} onChange={e => setResetEmail(e.target.value)} required />
              <button type="submit" disabled={loading}>{loading ? "Sending..." : "Send Reset Link"}</button>
            </form>
            <p className="auth-back" onClick={() => setMode('login')}>← Back to Login</p>
          </div>
        )}
      </div>
      
      {/* Bottom Icons */}
      {mode === 'landing' && (
        <div className="auth-icons-grid">
          <div className="auth-icon-box">
            <span>🔞</span>
            <strong>Adults Only</strong>
            <small>18+ Verified</small>
          </div>
          <div className="auth-icon-box">
            <span>🔥</span>
            <strong>Swingers</strong>
            <small>Couples & Singles</small>
          </div>
          <div className="auth-icon-box">
            <span>💎</span>
            <strong>Discreet</strong>
            <small>Private & Secure</small>
          </div>
          <div className="auth-icon-box">
            <span>✓</span>
            <strong>Verified</strong>
            <small>Real Profiles</small>
          </div>
          <div className="auth-icon-box">
            <span>⚡</span>
            <strong>Hookups</strong>
            <small>Meet Tonight</small>
          </div>
        </div>
      )}
      
      {/* Cookie Consent */}
      {!acceptedTerms && mode === 'landing' && (
        <div className="cookie-consent">
          <p>We use cookies to enhance your experience. By continuing, you agree to our <span onClick={() => setShowTerms('terms')}>Terms</span>, <span onClick={() => setShowTerms('privacy')}>Privacy Policy</span> & <span onClick={() => setShowTerms('cookies')}>Cookies</span>.</p>
          <button onClick={() => setAcceptedTerms(true)}>Accept All</button>
        </div>
      )}
      
      {/* Terms Modal */}
      {showTerms && (
        <div className="modal" onClick={() => setShowTerms(false)}>
          <div className="modal-content legal-modal-content" onClick={e => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setShowTerms(false)}>✕</button>
            {showTerms === 'terms' && <LegalTerms />}
            {showTerms === 'privacy' && <LegalPrivacy />}
            {showTerms === 'cookies' && <LegalCookiesCS />}
          </div>
        </div>
      )}
    </div>
  );
};

// RESET PASSWORD PAGE
const ResetPasswordPage = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();
  
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');

  const handleReset = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    if (password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }
    setLoading(true);
    setError('');
    try {
      await axios.post(`${API}/auth/reset-password?token=${token}&new_password=${password}`);
      setSuccess(true);
    } catch (e) {
      setError(e.response?.data?.detail || 'Failed to reset password');
    }
    setLoading(false);
  };

  if (!token) {
    return (
      <div className="auth-page launch-mode">
        <div className="auth-bg-overlay"></div>
        <div className="auth-content">
          <div className="auth-form">
            <h2>Invalid Link</h2>
            <p>This password reset link is invalid or has expired.</p>
            <button onClick={() => navigate('/')}>Back to Login</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page launch-mode">
      <div className="auth-bg-overlay"></div>
      <div className="auth-content">
        <div className="auth-form">
          {success ? (
            <>
              <h2>Password Reset!</h2>
              <p className="auth-success">Your password has been reset successfully.</p>
              <button onClick={() => navigate('/')}>Go to Login</button>
            </>
          ) : (
            <>
              <h2>Set New Password</h2>
              {error && <div className="auth-error">{error}</div>}
              <form onSubmit={handleReset}>
                <input type="password" placeholder="New password (min 6 chars)" value={password} onChange={e => setPassword(e.target.value)} required />
                <input type="password" placeholder="Confirm new password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required />
                <button type="submit" disabled={loading}>{loading ? 'Resetting...' : 'Reset Password'}</button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

// SIGNUP PAGE - Restructured with better flow and image cropping
const SignupPage = () => {
  const [step, setStep] = useState(1);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showCropper, setShowCropper] = useState(false);
  const [tempImage, setTempImage] = useState(null);
  const [cropPos, setCropPos] = useState({ x: 0, y: 0 });
  const [cropZoom, setCropZoom] = useState(1);
  const [gpsLoading, setGpsLoading] = useState(false);
  const [verificationPhoto, setVerificationPhoto] = useState(null);
  const [selfieLeft, setSelfieLeft] = useState(null);
  const [selfieCenter, setSelfieCenter] = useState(null);
  const [selfieRight, setSelfieRight] = useState(null);
  const [verifying, setVerifying] = useState(false);
  const { signup, config } = useAuth();
  const navigate = useNavigate();
  const totalSteps = 7;
  const fileInputRef = useRef(null);
  const selfieLeftRef = useRef(null);
  const selfieCenterRef = useRef(null);
  const selfieRightRef = useRef(null);
  const canvasRef = useRef(null);

  // Debug: Log config when it changes
  useEffect(() => {
    console.log('SignupPage - Config:', config);
    if (config) {
      console.log('Genders available:', config.genders?.length);
      console.log('Profile types available:', config.profile_types?.length);
    }
  }, [config]);

  const [form, setForm] = useState({
    name: "", email: "", password: "", confirmPassword: "",
    date_of_birth: "", gender: "", profile_type: "",
    location: { city: "", suburb: "", lat: null, lng: null },
    seeking: [], looking_for: [], interests: [], bio: "", profile_photo: null
  });

  const calcAge = (dob) => {
    if (!dob) return 0;
    const b = new Date(dob), t = new Date();
    let a = t.getFullYear() - b.getFullYear();
    if (t.getMonth() < b.getMonth() || (t.getMonth() === b.getMonth() && t.getDate() < b.getDate())) a--;
    return a;
  };

  const getGPSLocation = () => {
    setGpsLoading(true);
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          setForm(f => ({
            ...f,
            location: { ...f.location, lat: pos.coords.latitude, lng: pos.coords.longitude }
          }));
          setGpsLoading(false);
        },
        (err) => {
          console.log('GPS error:', err);
          setGpsLoading(false);
        },
        { enableHighAccuracy: true, timeout: 10000 }
      );
    } else {
      setGpsLoading(false);
    }
  };

  const toggle = (field, val) => {
    setForm(f => ({ ...f, [field]: f[field].includes(val) ? f[field].filter(v => v !== val) : [...f[field], val] }));
  };

  const handleFileSelect = async (e) => {
    const file = e.target.files?.[0];
    if (file) {
      try {
        // Compress profile photo: 600px for mobile memory efficiency
        const compressed = await compressImage(file, 600, 0.75);
        setTempImage(compressed);
        setShowCropper(true);
      } catch (err) {
        console.error('Image compression error:', err);
        setError('Failed to process image. Please try a smaller photo.');
      }
    }
    // Clear input to free memory
    e.target.value = '';
  };

  const handleVerifyPhoto = (which) => async (e) => {
    const file = e.target.files?.[0];
    if (file) {
      try {
        // Very aggressive compression for selfies: 400px max, 60% quality
        // This significantly reduces memory usage on mobile
        const compressed = await compressImage(file, 400, 0.6);
        if (which === 'left') setSelfieLeft(compressed);
        else if (which === 'right') setSelfieRight(compressed);
        else { setSelfieCenter(compressed); setVerificationPhoto(compressed); }
      } catch (err) {
        console.error('Selfie compression error:', err);
        setError('Failed to process image. Please try again with a smaller photo.');
      }
    }
    // Reset input value to allow re-selecting same file and free memory
    e.target.value = '';
  };

  const applyCrop = () => {
    setForm(f => ({ ...f, profile_photo: tempImage }));
    setShowCropper(false);
    setTempImage(null);
  };

  const validate = () => {
    setError("");
    if (step === 1 && (!form.name || !form.email.includes("@") || form.password.length < 6 || form.password !== form.confirmPassword)) 
      return setError("Fill all fields correctly") || false;
    if (step === 2 && (!form.date_of_birth || calcAge(form.date_of_birth) < 18 || !form.gender || !form.profile_type || !form.location.city)) 
      return setError("Must be 18+ and fill all fields") || false;
    if (step === 3 && (form.seeking.length === 0 || form.looking_for.length === 0)) return setError("Select at least one in each section") || false;
    if (step === 4 && form.interests.length === 0) return setError("Select at least one interest") || false;
    if (step === 5 && !form.profile_photo) return setError("Upload a profile photo") || false;
    if (step === 6 && (!selfieLeft || !selfieCenter || !selfieRight)) return setError("Take all 3 verification selfies") || false;
    return true;
  };

  const next = () => validate() && setStep(s => s + 1);
  const prev = () => setStep(s => s - 1);

  const submit = async () => {
    if (!validate()) return;
    setLoading(true);
    try {
      await signup({ ...form, selfie_left: selfieLeft, selfie_center: selfieCenter, selfie_right: selfieRight, confirmPassword: undefined });
      navigate("/home");
    } catch (e) {
      setError(e.response?.data?.detail || "Signup failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page signup-mode">
      <div className="auth-bg" style={{ backgroundImage: `url(${BG_WOMAN})`, opacity: 0.3 }}></div>
      <div className="auth-content">
        <div className="auth-brand small">FWB SA</div>
        <p className="auth-tagline">No Games. Just Heat.</p>
        <div className="progress"><div style={{ width: `${(step / totalSteps) * 100}%` }}></div></div>
        <p className="step-num">Step {step} of {totalSteps}</p>
        
        <div className="auth-form wide">
          {error && <div className="auth-error">{error}</div>}

          {step === 1 && (
            <>
              <h2>Create Account</h2>
              <div className="form-row">
                <div className="form-group">
                  <label>Display Name</label>
                  <input placeholder="Your name" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
                </div>
                <div className="form-group">
                  <label>Email</label>
                  <input type="email" placeholder="your@email.com" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Password (min 6)</label>
                  <input type="password" placeholder="••••••" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} />
                </div>
                <div className="form-group">
                  <label>Confirm Password</label>
                  <input type="password" placeholder="••••••" value={form.confirmPassword} onChange={e => setForm({ ...form, confirmPassword: e.target.value })} />
                </div>
              </div>
            </>
          )}

          {step === 2 && (
            <>
              <h2>About You</h2>
              <div className="form-row">
                <div className="form-group">
                  <label>Date of Birth</label>
                  <input type="date" value={form.date_of_birth} onChange={e => setForm({ ...form, date_of_birth: e.target.value })} />
                  {form.date_of_birth && <span className="age-tag">Age: {calcAge(form.date_of_birth)}</span>}
                </div>
                <div className="form-group">
                  <label>City</label>
                  <select value={form.location.city} onChange={e => setForm({ ...form, location: { ...form.location, city: e.target.value } })}>
                    <option value="">Select City</option>
                    {config?.cities?.map(c => <option key={c.name} value={c.name}>{c.name}</option>)}
                  </select>
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Gender</label>
                  <select value={form.gender} onChange={e => setForm({ ...form, gender: e.target.value })}>
                    <option value="">Select</option>
                    {config?.genders?.map(g => <option key={g.value} value={g.value}>{g.label}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>Profile Type</label>
                  <select value={form.profile_type} onChange={e => setForm({ ...form, profile_type: e.target.value })}>
                    <option value="">Select</option>
                    {config?.profile_types?.map(p => <option key={p.value} value={p.value}>{p.label}</option>)}
                  </select>
                </div>
              </div>
              <div className="form-group">
                <label>Suburb (optional)</label>
                <input placeholder="Your suburb" value={form.location.suburb} onChange={e => setForm({ ...form, location: { ...form.location, suburb: e.target.value } })} />
              </div>
              <button type="button" className="gps-btn" onClick={getGPSLocation} disabled={gpsLoading}>
                {gpsLoading ? '📍 Getting location...' : form.location.lat ? '✓ Location detected' : '📍 Use My Location'}
              </button>
            </>
          )}

          {step === 3 && (
            <>
              <h2>Preferences</h2>
              <div className="pref-section">
                <h3>Who Are You Seeking?</h3>
                <div className="check-grid cols-2">
                  {config?.seeking?.map(o => (
                    <label key={o.value} className={form.seeking.includes(o.value) ? 'sel' : ''}>
                      <input type="checkbox" checked={form.seeking.includes(o.value)} onChange={() => toggle('seeking', o.value)} />
                      {o.label}
                    </label>
                  ))}
                </div>
              </div>
              <div className="pref-section">
                <h3>What Are You Looking For?</h3>
                <div className="check-grid cols-2">
                  {config?.looking_for?.map(o => (
                    <label key={o.value} className={form.looking_for.includes(o.value) ? 'sel' : ''}>
                      <input type="checkbox" checked={form.looking_for.includes(o.value)} onChange={() => toggle('looking_for', o.value)} />
                      {o.label}
                    </label>
                  ))}
                </div>
              </div>
            </>
          )}

          {step === 4 && (
            <>
              <h2>Your Interests</h2>
              <div className="check-grid cols-3">
                {config?.interests?.map(o => (
                  <label key={o.value} className={`sm ${form.interests.includes(o.value) ? 'sel' : ''}`}>
                    <input type="checkbox" checked={form.interests.includes(o.value)} onChange={() => toggle('interests', o.value)} />
                    {o.label}
                  </label>
                ))}
              </div>
            </>
          )}

          {step === 5 && (
            <>
              <h2>Profile Photo</h2>
              <p className="form-hint">This will be your main profile picture</p>
              <div className="photo-box" onClick={() => fileInputRef.current?.click()}>
                {form.profile_photo ? <img src={form.profile_photo} alt="" /> : <><span>📷</span><p>Click to upload</p></>}
              </div>
              <input ref={fileInputRef} type="file" accept="image/*" onChange={handleFileSelect} style={{ display: 'none' }} />
              {form.profile_photo && (
                <div className="photo-actions">
                  <button className="btn-crop" onClick={() => { setTempImage(form.profile_photo); setShowCropper(true); }}>✂️ Adjust</button>
                  <button className="btn-remove" onClick={() => setForm(f => ({ ...f, profile_photo: null }))}>🗑️ Remove</button>
                </div>
              )}
            </>
          )}

          {step === 6 && (
            <>
              <h2>Verify Your Profile</h2>
              <p className="form-hint">Take 3 selfies to prove you're a real person. This keeps our community safe.</p>
              <div className="verify-instructions">
                <p>1. Look LEFT</p>
                <p>2. Look STRAIGHT at camera</p>
                <p>3. Look RIGHT</p>
              </div>
              <div className="selfie-grid">
                <div className="photo-box small" onClick={() => selfieLeftRef.current?.click()}>
                  {selfieLeft ? <img src={selfieLeft} alt="" /> : <><span>👈</span><p>Look Left</p></>}
                </div>
                <div className="photo-box small" onClick={() => selfieCenterRef.current?.click()}>
                  {selfieCenter ? <img src={selfieCenter} alt="" /> : <><span>📸</span><p>Look Straight</p></>}
                </div>
                <div className="photo-box small" onClick={() => selfieRightRef.current?.click()}>
                  {selfieRight ? <img src={selfieRight} alt="" /> : <><span>👉</span><p>Look Right</p></>}
                </div>
              </div>
              <input ref={selfieLeftRef} type="file" accept="image/*" onChange={handleVerifyPhoto('left')} style={{ display: 'none' }} />
              <input ref={selfieCenterRef} type="file" accept="image/*" onChange={handleVerifyPhoto('center')} style={{ display: 'none' }} />
              <input ref={selfieRightRef} type="file" accept="image/*" onChange={handleVerifyPhoto('right')} style={{ display: 'none' }} />
              {selfieLeft && selfieCenter && selfieRight && (
                <div className="verify-status">
                  <span>✓</span> All 3 selfies captured - ready for verification
                </div>
              )}
            </>
          )}

          {step === 7 && (
            <>
              <h2>About You (Optional)</h2>
              <textarea placeholder="Tell others about yourself, what you're into, what you're looking for..." value={form.bio} onChange={e => setForm({ ...form, bio: e.target.value })} rows={5}></textarea>
              <div className="signup-preview">
                <h4>Profile Preview</h4>
                <div className="preview-card">
                  <div className="preview-img">{form.profile_photo ? <img src={form.profile_photo} alt="" /> : '👤'}</div>
                  <div className="preview-info">
                    <strong>{form.name}, {calcAge(form.date_of_birth)}</strong>
                    <span>{form.profile_type?.replace(/_/g, ' ')}</span>
                    <span>📍 {form.location.city}</span>
                  </div>
                </div>
              </div>
            </>
          )}

          <div className="form-btns">
            {step > 1 ? <button className="btn-back" onClick={prev}>Back</button> : <button className="btn-back" onClick={() => navigate('/')}>Cancel</button>}
            {step < totalSteps ? <button className="btn-next" onClick={next}>Continue</button> : <button className="btn-submit" onClick={submit} disabled={loading}>{loading ? "Creating..." : "Create Profile"}</button>}
          </div>
        </div>

        {/* Image Cropper Modal */}
        {showCropper && (
          <div className="crop-modal">
            <div className="crop-content">
              <h3>Adjust Your Photo</h3>
              <div className="crop-preview">
                <img src={tempImage} alt="" style={{ transform: `scale(${cropZoom})` }} />
              </div>
              <div className="crop-controls">
                <label>Zoom</label>
                <input type="range" min="1" max="3" step="0.1" value={cropZoom} onChange={e => setCropZoom(parseFloat(e.target.value))} />
              </div>
              <div className="crop-btns">
                <button onClick={() => setShowCropper(false)}>Cancel</button>
                <button className="primary" onClick={applyCrop}>Apply</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

// HOME PAGE (Dashboard) - Main landing after login with all sections
const HomePage = () => {
  const { user, token, config } = useAuth();
  const [data, setData] = useState({ online: [], nearby: [], recent: [], photos: [], events: [], activity: {} });
  const [loading, setLoading] = useState(true);
  const [nearbyUsers, setNearbyUsers] = useState([]);
  const [displayArticles] = useState(() => {
    const slugs = Object.keys(ARTICLES);
    const shuffled = [...slugs].sort(() => Math.random() - 0.5);
    return shuffled.slice(0, 4);
  });
  const navigate = useNavigate();

  const tier = user?.membership_tier || 'silver';
  const isAdmin = user?.email === 'admin@fwbsa.co.za' || user?.role === 'admin' || user?.role === 'owner';
  const isSilver = tier === 'silver' && !isAdmin;
  const canSee = tier === 'gold' || tier === 'platinum' || isAdmin;
  const canCreateEvents = tier === 'gold' || tier === 'platinum' || isAdmin;

  // Geolocation for nearby map (Platinum)
  useEffect(() => {
    if (tier !== 'platinum' && !isAdmin) return;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(async (pos) => {
        try {
          await axios.put(`${API}/users/me`, { location: { lat: pos.coords.latitude, lng: pos.coords.longitude, city: user?.location?.city || '' } }, { headers: { Authorization: `Bearer ${token}` } });
          const res = await axios.get(`${API}/users/nearby?limit=12`, { headers: { Authorization: `Bearer ${token}` } });
          setNearbyUsers(res.data || []);
        } catch(e) {}
      }, () => {
        // Fallback to city-based
        axios.get(`${API}/users/nearby?limit=12`, { headers: { Authorization: `Bearer ${token}` } }).then(r => setNearbyUsers(r.data || [])).catch(()=>{});
      });
    } else {
      axios.get(`${API}/users/nearby?limit=12`, { headers: { Authorization: `Bearer ${token}` } }).then(r => setNearbyUsers(r.data || [])).catch(()=>{});
    }
  }, [tier, token]);

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const [online, nearby, recent, photos, events, activity] = await Promise.all([
          axios.get(`${API}/users/online?limit=8`, { headers: { Authorization: `Bearer ${token}` } }),
          axios.get(`${API}/users/nearby?limit=8`, { headers: { Authorization: `Bearer ${token}` } }),
          axios.get(`${API}/users/recent?limit=8`, { headers: { Authorization: `Bearer ${token}` } }),
          axios.get(`${API}/photos/recent?limit=10`, { headers: { Authorization: `Bearer ${token}` } }),
          axios.get(`${API}/events?limit=3`, { headers: { Authorization: `Bearer ${token}` } }),
          axios.get(`${API}/activity/summary`, { headers: { Authorization: `Bearer ${token}` } })
        ]);
        setData({ online: online.data, nearby: nearby.data, recent: recent.data, photos: photos.data, events: events.data, activity: activity.data });
      } catch (e) { console.error(e); }
      setLoading(false);
    };
    fetchAll();
  }, [token]);

  const MiniCard = ({ u }) => (
    <div className={`mini-card ${isSilver ? 'locked' : ''}`} onClick={() => canSee ? navigate(`/user/${u.id}`) : navigate('/membership')}>
      <div className="mc-img">
        {u.profile_photo ? <img src={u.profile_photo} alt="" className={isSilver ? 'blur' : ''} /> : <span>{u.gender === 'female' ? '👩' : '👨'}</span>}
        {u.is_online && <div className="online-dot"></div>}
      </div>
      <div className="mc-info">
        <span className="mc-name">{canSee ? u.name : '•••'}</span>
        <span className="mc-age">{u.age}</span>
      </div>
      {isSilver && <div className="lock-overlay sm">🔒</div>}
    </div>
  );

  if (loading) return <div className="page-wrap"><Nav /><div className="loading-screen"><div className="spinner"></div></div></div>;

  return (
    <div className="page-wrap">
      <Nav />
      <div className="home-page compact">
        {/* Welcome & Activity Summary */}
        <div className="home-header">
          <div className="welcome-box">
            <h1>Welcome, {user?.name}</h1>
            <p>Your tier: <span className={`tier-badge ${tier}`}>{tier.toUpperCase()}</span></p>
          </div>
          <div className="activity-summary">
            <div className="activity-item" onClick={() => canSee ? navigate('/activity/views') : navigate('/membership')}>
              <span className="num">{data.activity.views || 0}</span>
              <span className="label">Viewed You</span>
              {isSilver && <span className="lock-icon">🔒</span>}
            </div>
            <div className="activity-item" onClick={() => canSee ? navigate('/activity/likes') : navigate('/membership')}>
              <span className="num">{data.activity.likes || 0}</span>
              <span className="label">Liked You</span>
              {isSilver && <span className="lock-icon">🔒</span>}
            </div>
            <div className="activity-item" onClick={() => navigate('/inbox')}>
              <span className="num">{data.activity.matches || 0}</span>
              <span className="label">Matches</span>
            </div>
            <div className="activity-item" onClick={() => navigate('/inbox')}>
              <span className="num">{data.activity.messages || 0}</span>
              <span className="label">Messages</span>
            </div>
          </div>
        </div>

        {/* Upgrade Banner for Silver */}
        {isSilver && (
          <div className="upgrade-banner" onClick={() => navigate('/membership')}>
            <span>🔥 Upgrade your membership to view profiles clearly and unlock all features</span>
            <button>Upgrade Now</button>
          </div>
        )}

        {/* Online Now */}
        <section className="home-section">
          <div className="section-header">
            <h2>🟢 Online Now</h2>
            <button onClick={() => navigate('/meet')}>See All</button>
          </div>
          <div className="mini-grid">
            {data.online.length === 0 ? <p className="empty">No one online right now</p> : data.online.map(u => <MiniCard key={u.id} u={u} />)}
          </div>
        </section>

        {/* Nearby */}
        <section className="home-section">
          <div className="section-header">
            <h2>📍 Nearby</h2>
            <button onClick={() => navigate('/meet')}>See All</button>
          </div>
          <div className="mini-grid">
            {data.nearby.length === 0 ? <p className="empty">No one nearby</p> : data.nearby.map(u => <MiniCard key={u.id} u={u} />)}
          </div>
        </section>

        {/* Recently Joined */}
        <section className="home-section">
          <div className="section-header">
            <h2>🆕 Recently Joined</h2>
            <button onClick={() => navigate('/meet')}>See All</button>
          </div>
          <div className="mini-grid">
            {data.recent.length === 0 ? <p className="empty">No recent signups</p> : data.recent.map(u => <MiniCard key={u.id} u={u} />)}
          </div>
        </section>

        {/* Parties & Events - Gold+ can create/join */}
        <section className="home-section">
          <div className="section-header">
            <h2>🎉 Parties & Events</h2>
            {canCreateEvents && <button className="create-btn" onClick={() => navigate('/events')}>+ Create</button>}
          </div>
          <div className="events-row">
            {data.events.length === 0 ? (
              <div className="empty-events">
                <p>No upcoming events</p>
                {!canCreateEvents && <span className="tier-hint">Gold+ members can create and join parties</span>}
              </div>
            ) : data.events.map(e => (
              <div key={e.id} className={`event-card ${isSilver ? 'locked' : ''}`} onClick={() => canSee ? navigate(`/events/${e.id}`) : navigate('/membership')}>
                <div className="event-date">{new Date(e.event_date).toLocaleDateString('en-ZA', { day: 'numeric', month: 'short' })}</div>
                <h3>{canSee ? e.title : '•••••'}</h3>
                <p>{e.location}</p>
                <span className="event-type">{e.event_type}</span>
                {isSilver && <div className="lock-overlay">🔒</div>}
              </div>
            ))}
          </div>
        </section>

        {/* Recent Photos */}
        <section className="home-section">
          <div className="section-header">
            <h2>📸 Recent Photos</h2>
            <button onClick={() => navigate('/media')}>See All</button>
          </div>
          <div className="photos-mini-grid">
            {data.photos.length === 0 ? <p className="empty">No recent photos</p> : data.photos.slice(0, 10).map((p, i) => (
              <div key={i} className={`photo-mini ${isSilver ? 'locked' : ''}`} onClick={() => navigate('/media')}>
                <img src={p.photo_url} alt="" className={isSilver ? 'blur' : ''} />
                {isSilver && <div className="lock-overlay sm">🔒</div>}
              </div>
            ))}
          </div>
        </section>

        {/* Quick Actions */}
        <div className="quick-actions">
          <button onClick={() => navigate('/meet')}>Find Matches</button>
          <button onClick={() => navigate('/socials')}>Socials</button>
          <button onClick={() => navigate('/inbox')}>Inbox</button>
        </div>

        {/* Articles & Tips Section */}
        <section className="home-section articles-section">
          <div className="section-header">
            <h2>Tips & Advice</h2>
          </div>
          <div className="articles-grid">
            {displayArticles.map(slug => { const art = ARTICLES[slug]; return (
              <div key={slug} className="article-card" data-testid={"article-"+slug} onClick={() => navigate("/articles/"+slug)}>
                <div className="article-icon">{art.icon}</div>
                <h3>{art.title}</h3>
                <p>{art.teaser}</p>
              </div>
            ); })}
          </div>
        </section>

        {/* Who's Nearby - Platinum Only */}
        {(tier === 'platinum' || isAdmin) && (
          <section className="home-section nearby-map-section">
            <div className="section-header">
              <h2>📍 Who's Nearby</h2>
            </div>
            <div className="nearby-map" data-testid="nearby-map">
              <div className="map-container" style={{background:'#12121e',borderRadius:16,padding:20,position:'relative',minHeight:300,overflow:'hidden'}}>
                {/* Map Grid */}
                <div style={{position:'absolute',inset:0,opacity:0.1,backgroundImage:'radial-gradient(circle,#14b8a6 1px,transparent 1px)',backgroundSize:'20px 20px'}}></div>
                <div style={{position:'absolute',top:'50%',left:'50%',transform:'translate(-50%,-50%)',width:16,height:16,borderRadius:'50%',background:'#e94560',boxShadow:'0 0 20px rgba(233,69,96,0.6)',zIndex:5}}></div>
                <div style={{position:'absolute',top:'50%',left:'50%',transform:'translate(-50%,-50%)',width:120,height:120,borderRadius:'50%',border:'1px solid rgba(233,69,96,0.2)',zIndex:1}}></div>
                <div style={{position:'absolute',top:'50%',left:'50%',transform:'translate(-50%,-50%)',width:220,height:220,borderRadius:'50%',border:'1px solid rgba(233,69,96,0.1)',zIndex:1}}></div>
                {nearbyUsers.slice(0, 8).map((u, i) => {
                  const angle = (i / Math.max(data.nearby.length, 1)) * Math.PI * 2;
                  const dist = 60 + Math.random() * 80;
                  const x = 50 + Math.cos(angle) * (dist / 3);
                  const y = 50 + Math.sin(angle) * (dist / 3);
                  return (
                    <div key={u.id || i} onClick={() => navigate(`/user/${u.id}`)} style={{position:'absolute',top:`${y}%`,left:`${x}%`,transform:'translate(-50%,-50%)',cursor:'pointer',zIndex:3,textAlign:'center'}} data-testid={`nearby-user-${i}`}>
                      <div style={{width:40,height:40,borderRadius:'50%',overflow:'hidden',border:'2px solid #14b8a6',margin:'0 auto 4px'}}>
                        {u.profile_photo ? <img src={u.profile_photo} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}} /> : <div style={{width:'100%',height:'100%',background:'#2a2a3e',display:'flex',alignItems:'center',justifyContent:'center',fontSize:16}}>👤</div>}
                      </div>
                      <span style={{color:'#fff',fontSize:11,fontWeight:600}}>{u.name?.split(' ')[0]}</span>
                      {u.is_online && <span style={{display:'block',color:'#22c55e',fontSize:10}}>Online</span>}
                    </div>
                  );
                })}
                {(!data.nearby || data.nearby.length === 0) && <p style={{textAlign:'center',color:'#888',position:'relative',zIndex:5,paddingTop:120}}>No one nearby right now</p>}
              </div>
            </div>
          </section>
        )}
        {tier !== 'platinum' && !isAdmin && (
          <section className="home-section">
            <div className="section-header"><h2>📍 Who's Nearby</h2></div>
            <div style={{background:'#12121e',borderRadius:16,padding:24,textAlign:'center'}}>
              <p style={{color:'#888',marginBottom:12}}>See who's near you in real-time</p>
              <button onClick={() => navigate('/membership')} style={{background:'linear-gradient(135deg,#e94560,#ff6b6b)',color:'#fff',border:'none',padding:'10px 24px',borderRadius:8,cursor:'pointer',fontWeight:600}}>Upgrade to Platinum</button>
            </div>
          </section>
        )}

        {/* Early Access Notice */}
        <div className="early-access-banner">
          <span>🚀 Early Access Launch</span>
          <p>We're in our early launch phase! Limited profiles as we grow. First 200 members get FREE Gold for 3 months. Women always get Gold free!</p>
        </div>
      </div>
    </div>
  );
};

// MEET PAGE (Swipe)
const MeetPage = () => {
  const { token, user, config, refreshUser } = useAuth();
  const [cards, setCards] = useState([]);
  const [idx, setIdx] = useState(0);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const tier = config?.membership_tiers?.[user?.membership_tier] || {};
  const superLikes = tier.super_likes_per_day === -1 ? '∞' : Math.max(0, (tier.super_likes_per_day || 1) - (user?.super_likes_today || 0));

  useEffect(() => {
    axios.get(`${API}/matching/cards?limit=20`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => { setCards(r.data); setIdx(0); })
      .finally(() => setLoading(false));
  }, [token]);

  const action = async (type) => {
    if (!cards[idx]) return;
    try {
      const res = await axios.post(`${API}/matching/action`, { user_id: cards[idx].id, action: type }, { headers: { Authorization: `Bearer ${token}` } });
      if (res.data.is_match) alert(res.data.message);
      if (type === 'super_like') await refreshUser();
      setIdx(i => i + 1);
    } catch (e) {
      alert(e.response?.data?.detail || 'Failed');
    }
  };

  const rewind = async () => {
    try {
      const res = await axios.post(`${API}/matching/rewind`, {}, { headers: { Authorization: `Bearer ${token}` } });
      if (res.data.user) { setCards(c => [res.data.user, ...c]); setIdx(0); await refreshUser(); }
      alert(res.data.message);
    } catch (e) { alert(e.response?.data?.detail || 'Failed'); }
  };

  const card = cards[idx];
  const [showCardDetail, setShowCardDetail] = useState(false);

  return (
    <div className="page-wrap">
      <Nav />
      <div className="meet-page">
        <h1>Find Your Match</h1>
        
        {loading ? <div className="loading"><div className="spinner"></div></div> : !card ? (
          <div className="no-cards">
            <h2>No more profiles</h2>
            <p>Check back later</p>
            <button onClick={() => window.location.reload()}>Refresh</button>
          </div>
        ) : (
          <div className="swipe-area">
            <div className="swipe-card" onClick={() => setShowCardDetail(!showCardDetail)} style={{cursor:'pointer'}}>
              <div className="sc-img">
                {card.profile_photo ? <img src={card.profile_photo} alt="" /> : <span>{card.gender === 'female' ? '👩' : '👨'}</span>}
                {card.is_verified && <div className="verified">✓ Verified</div>}
              </div>
              <div className="sc-info">
                <h2>{card.name}, {card.age}</h2>
                <p className="sc-type">{card.profile_type?.replace(/_/g, ' ')}</p>
                <p className="sc-loc">📍 {card.location?.city}</p>
                <p style={{color:'#888',fontSize:12,marginTop:4}}>Tap to see more info</p>
              </div>
            </div>

            {/* Profile Detail Modal */}
            {showCardDetail && (
              <div className="modal-overlay" onClick={() => setShowCardDetail(false)} style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.85)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}}>
                <div onClick={e => e.stopPropagation()} style={{background:'#1a1a2e',borderRadius:16,padding:20,maxWidth:400,width:'90%',maxHeight:'80vh',overflow:'auto'}}>
                  <div style={{display:'flex',gap:8,marginBottom:16}}>
                    <div style={{width:80,height:80,borderRadius:12,overflow:'hidden',flexShrink:0}}>
                      {card.profile_photo ? <img src={card.profile_photo} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}} /> : <div style={{width:'100%',height:'100%',background:'#2a2a3e',display:'flex',alignItems:'center',justifyContent:'center',fontSize:32}}>👤</div>}
                    </div>
                    <div>
                      <h3 style={{color:'#fff',marginBottom:4}}>{card.name}, {card.age}</h3>
                      <p style={{color:'#14b8a6',fontSize:14}}>{card.profile_type?.replace(/_/g, ' ')}</p>
                      <p style={{color:'#888',fontSize:13}}>📍 {card.location?.city}</p>
                    </div>
                  </div>
                  
                  {/* Display pics grid */}
                  {card.photos?.length > 0 && (
                    <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:6,marginBottom:16}}>
                      {card.photos.slice(0, 3).map((p, i) => (
                        <div key={i} style={{borderRadius:8,overflow:'hidden',aspectRatio:'1'}}>
                          <img src={p} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}} />
                        </div>
                      ))}
                    </div>
                  )}

                  {card.bio && <p style={{color:'#ccc',lineHeight:1.6,marginBottom:12}}>{card.bio}</p>}
                  
                  <div style={{display:'flex',flexWrap:'wrap',gap:6,marginBottom:12}}>
                    {card.looking_for?.map(t => <span key={t} style={{background:'#2a2a3e',color:'#ccc',padding:'4px 10px',borderRadius:20,fontSize:12}}>{t.replace(/_/g, ' ')}</span>)}
                  </div>
                  
                  {card.interests?.length > 0 && (
                    <div style={{display:'flex',flexWrap:'wrap',gap:6,marginBottom:16}}>
                      {card.interests.map(t => <span key={t} style={{background:'rgba(20,184,166,0.15)',color:'#14b8a6',padding:'4px 10px',borderRadius:20,fontSize:12}}>{t}</span>)}
                    </div>
                  )}
                  
                  <button onClick={() => setShowCardDetail(false)} style={{width:'100%',background:'#14b8a6',color:'#000',border:'none',padding:'12px',borderRadius:8,cursor:'pointer',fontWeight:600}}>Close</button>
                </div>
              </div>
            )}

            <div className="swipe-btns">
              <button className="btn-rew" onClick={rewind}>↩</button>
              <button className="btn-pass" onClick={() => action('pass')}>✕</button>
              <button className="btn-star" onClick={() => action('super_like')}>★</button>
              <button className="btn-like" onClick={() => action('like')}>♥</button>
            </div>
            <p className="swipe-info">Super Likes: {superLikes} | Cards: {cards.length - idx - 1}</p>
          </div>
        )}
      </div>
    </div>
  );
};

// SOCIALS PAGE
const SocialsPage = () => {
  const { token, user, config } = useAuth();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCreate, setShowCreate] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);
  const [newPost, setNewPost] = useState({ title: '', description: '', who_am_i: 'couple', timeframe: 'tonight', looking_for: [] });
  const navigate = useNavigate();

  const tier = user?.membership_tier || 'silver';
  const isAdmin = user?.email === 'admin@fwbsa.co.za' || user?.role === 'owner' || user?.role === 'admin';
  const isSilver = tier === 'silver' && !isAdmin;
  const isGold = tier === 'gold' && !isAdmin;
  const isPlatinum = tier === 'platinum' || isAdmin;
  const canSeeClearly = !isSilver;
  const canRespond = isPlatinum;

  const whoOptions = ['single_male', 'single_female', 'couple', 'group'];
  const timeOptions = ['right_now', 'tonight', 'this_weekend', 'flexible'];
  const lookingOptions = ['single_males', 'single_females', 'couples', 'groups', 'anyone'];

  const loadPosts = () => {
    axios.get(`${API}/socials`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setPosts(r.data.posts || []))
      .finally(() => setLoading(false));
  };

  useEffect(() => { loadPosts(); }, [token]);

  const adminDeletePost = async (postId) => {
    if (!window.confirm('Delete this post?')) return;
    try {
      await axios.delete(`${API}/admin/socials/${postId}`, { headers: { Authorization: `Bearer ${token}` } });
      loadPosts();
    } catch (e) { alert('Failed'); }
  };

  const createPost = async () => {
    if (!newPost.title.trim() || !newPost.description.trim()) { alert('Please fill in title and description'); return; }
    try {
      await axios.post(`${API}/socials`, newPost, { headers: { Authorization: `Bearer ${token}` } });
      setNewPost({ title: '', description: '', who_am_i: 'couple', timeframe: 'tonight', looking_for: [] });
      setShowCreate(false);
      loadPosts();
    } catch (e) { alert(e.response?.data?.detail || 'Failed to create post'); }
  };

  const deletePost = async (postId) => {
    if (!window.confirm('Delete this post?')) return;
    try {
      await axios.delete(`${API}/socials/${postId}`, { headers: { Authorization: `Bearer ${token}` } });
      loadPosts();
    } catch (e) { alert('Failed to delete'); }
  };

  const toggleLookingFor = (opt) => {
    setNewPost(p => ({ ...p, looking_for: p.looking_for.includes(opt) ? p.looking_for.filter(x => x !== opt) : [...p.looking_for, opt] }));
  };

  if (loading) return <div className="page-wrap"><Nav /><div className="loading-screen"><div className="spinner"></div></div></div>;

  return (
    <div className="page-wrap">
      <Nav />
      <div className="socials-page">
        <div className="page-head">
          <h1>Socials & Meetups</h1>
          {canRespond && <button className="btn-create" onClick={() => setShowCreate(true)}>+ Create Post</button>}
        </div>
        <p className="page-desc">Instant meetups and connections</p>
        <div className="early-access-notice">Early Access Launch - Limited profiles as we grow. First 200 members get FREE Gold!</div>

        {isSilver && (
          <div className="tier-block">
            <p>See what's happening! Upgrade to <strong>Gold</strong> to view clearly, or <strong>Platinum</strong> to post & respond</p>
            <button onClick={() => navigate('/membership')}>Upgrade Now</button>
          </div>
        )}

        <div className="posts-list">
          {posts.length === 0 ? <p className="empty">No active posts yet. Be the first to post!</p> : posts.map(p => (
            <div key={p.id} className={`social-card ${isSilver ? 'locked' : ''}`} onClick={() => !isSilver && setSelectedPost(p)}>
              <div className="poster-avatar">
                {p.user_photo ? <img src={p.user_photo} alt="" /> : <div className="no-img">{p.who_am_i === 'single_female' ? '👩' : p.who_am_i === 'couple' ? '👫' : '👨'}</div>}
              </div>
              <div className="sc-content">
                <h3>{canSeeClearly ? p.title : '***********'}</h3>
                <p>{canSeeClearly ? (p.description?.slice(0, 100) + (p.description?.length > 100 ? '...' : '')) : '**********************'}</p>
                <div className="sc-tags">
                  <span className="sc-tag who">{canSeeClearly ? p.who_am_i?.replace(/_/g, ' ') : '***'}</span>
                  <span className="sc-tag time">{canSeeClearly ? p.timeframe?.replace(/_/g, ' ') : '***'}</span>
                  {canSeeClearly && p.looking_for?.slice(0, 2).map(l => <span key={l} className="sc-tag">{l.replace(/_/g, ' ')}</span>)}
                </div>
                <div className="sc-meta">
                  <span className="poster-name">{canSeeClearly ? (p.user_name || 'Anonymous') : '***'}</span>
                  <div className="sc-actions">
                    {canRespond && p.user_id !== user?.id && <button className="btn-respond" onClick={(e) => { e.stopPropagation(); navigate(`/messages/${p.user_id}`); }}>Message</button>}
                    {p.user_id === user?.id && <button className="btn-delete" onClick={(e) => { e.stopPropagation(); deletePost(p.id); }}>Delete</button>}
                    {isAdmin && p.user_id !== user?.id && <button className="btn-delete" onClick={(e) => { e.stopPropagation(); adminDeletePost(p.id); }}>Remove</button>}
                  </div>
                </div>
              </div>
              {isSilver && <div className="lock-overlay" onClick={() => navigate('/membership')}>Upgrade to View</div>}
            </div>
          ))}
        </div>
      </div>

      {/* Post Detail Modal */}
      {selectedPost && canSeeClearly && (
        <div className="modal-overlay" onClick={() => setSelectedPost(null)}>
          <div className="post-detail-modal" onClick={e => e.stopPropagation()}>
            <div className="poster-header">
              {selectedPost.user_photo ? <img src={selectedPost.user_photo} alt="" /> : <div className="no-img" style={{width:70,height:70,borderRadius:'50%',background:'#333',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'2rem'}}>{selectedPost.who_am_i === 'single_female' ? '👩' : '👨'}</div>}
              <div className="poster-info">
                <h3>{selectedPost.user_name || 'Anonymous'}</h3>
                <p>{selectedPost.who_am_i?.replace(/_/g, ' ')} • {selectedPost.timeframe?.replace(/_/g, ' ')}</p>
              </div>
            </div>
            <div className="post-body">
              <h2>{selectedPost.title}</h2>
              <p className="description">{selectedPost.description}</p>
              <div className="post-details">
                <div className="detail-row"><span className="detail-label">Looking for</span><span className="detail-value">{selectedPost.looking_for?.join(', ').replace(/_/g, ' ')}</span></div>
                <div className="detail-row"><span className="detail-label">When</span><span className="detail-value">{selectedPost.timeframe?.replace(/_/g, ' ')}</span></div>
                <div className="detail-row"><span className="detail-label">Posted</span><span className="detail-value">{new Date(selectedPost.created_at).toLocaleDateString()}</span></div>
              </div>
            </div>
            <div className="modal-actions" style={{marginTop: 20}}>
              <button className="btn-cancel" onClick={() => setSelectedPost(null)}>Close</button>
              {canRespond && selectedPost.user_id !== user?.id && <button className="btn-submit" onClick={() => { setSelectedPost(null); navigate(`/messages/${selectedPost.user_id}`); }}>Send Message</button>}
            </div>
          </div>
        </div>
      )}

      {showCreate && (
        <div className="modal-overlay" onClick={() => setShowCreate(false)}>
          <div className="modal-content create-modal" onClick={e => e.stopPropagation()}>
            <h3>Create Social Post</h3>
            <input type="text" placeholder="Title (e.g., Looking for tonight)" value={newPost.title} onChange={e => setNewPost({...newPost, title: e.target.value})} />
            <textarea placeholder="Describe what you're looking for..." value={newPost.description} onChange={e => setNewPost({...newPost, description: e.target.value})} rows={4} />
            <div className="form-group">
              <label>Who are you?</label>
              <select value={newPost.who_am_i} onChange={e => setNewPost({...newPost, who_am_i: e.target.value})}>
                {whoOptions.map(o => <option key={o} value={o}>{o.replace(/_/g, ' ')}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>Timeframe</label>
              <select value={newPost.timeframe} onChange={e => setNewPost({...newPost, timeframe: e.target.value})}>
                {timeOptions.map(o => <option key={o} value={o}>{o.replace(/_/g, ' ')}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>Looking for:</label>
              <div className="checkbox-group">
                {lookingOptions.map(o => (
                  <label key={o} className="checkbox-label">
                    <input type="checkbox" checked={newPost.looking_for.includes(o)} onChange={() => toggleLookingFor(o)} />
                    {o.replace(/_/g, ' ')}
                  </label>
                ))}
              </div>
            </div>
            <div className="modal-actions">
              <button className="btn-cancel" onClick={() => setShowCreate(false)}>Cancel</button>
              <button className="btn-submit" onClick={createPost}>Post</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// MEDIA PAGE
const MediaPage = () => {
  const { token, user } = useAuth();
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedIdx, setSelectedIdx] = useState(-1);
  const [selected, setSelected] = useState(null);
  const [filter, setFilter] = useState('recent');
  const navigate = useNavigate();

  const tier = user?.membership_tier || 'silver';
  const isAdmin = user?.role === 'admin' || user?.role === 'owner' || user?.email === 'admin@fwbsa.co.za';
  const isSilver = tier === 'silver' && !isAdmin;
  const isGold = tier === 'gold' && !isAdmin;
  const isPlatinum = tier === 'platinum' || isAdmin;

  // Silver: blurred, enlarged still blurred, no like/comment
  // Gold: sees clear, can enlarge, can like, can comment, CANNOT click poster profile
  // Platinum: sees clear, can enlarge, can like, can comment, CAN click poster profile

  const canSeeClear = !isSilver;
  const canEnlarge = true; // all tiers can enlarge
  const canLike = !isSilver; // gold + plat
  const canComment = !isSilver; // gold + plat
  const canViewPoster = isPlatinum; // plat only

  const loadPhotos = useCallback(() => {
    setLoading(true);
    axios.get(`${API}/media/gallery?limit=50&sort=${filter}`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setPhotos(r.data.photos || []))
      .finally(() => setLoading(false));
  }, [token, filter]);

  useEffect(() => { loadPhotos(); }, [loadPhotos]);

  const openPhoto = async (p, idx) => {
    setSelectedIdx(idx);
    try {
      const res = await axios.get(`${API}/media/photo/${p.id}`, { headers: { Authorization: `Bearer ${token}` } });
      setSelected(res.data);
    } catch (e) { setSelected(p); }
  };

  const goNext = () => {
    if (selectedIdx < photos.length - 1) { openPhoto(photos[selectedIdx + 1], selectedIdx + 1); }
  };
  const goPrev = () => {
    if (selectedIdx > 0) { openPhoto(photos[selectedIdx - 1], selectedIdx - 1); }
  };

  if (loading) return <div className="page-wrap"><Nav /><div className="loading-screen"><div className="spinner"></div></div></div>;

  return (
    <div className="page-wrap">
      <Nav />
      <div className="media-page">
        <div className="page-head">
          <h1>Media Gallery</h1>
        </div>
        <p className="page-desc">Recent uploads from members</p>

        {/* Filter tabs */}
        <div className="media-filters">
          <button className={filter === 'recent' ? 'active' : ''} onClick={() => setFilter('recent')}>Recently Added</button>
          <button className={filter === 'liked' ? 'active' : ''} onClick={() => setFilter('liked')}>Most Liked</button>
          <button className={filter === 'viewed' ? 'active' : ''} onClick={() => setFilter('viewed')}>Most Viewed</button>
        </div>

        {isSilver && (
          <div className="tier-block">
            <p>Photos are blurred. Upgrade to <strong>Gold</strong> to view clearly, like & comment.</p>
            <button onClick={() => navigate('/membership')}>Upgrade Now</button>
          </div>
        )}

        <div className="media-grid">
          {photos.length === 0 ? <p className="empty">No photos yet</p> : photos.map((p, i) => (
            <div key={i} className={`media-item ${isSilver ? 'locked' : ''}`} onClick={() => openPhoto(p, i)} data-testid={`media-item-${i}`}>
              <img src={p.photo_url} alt="" className={isSilver ? 'blur' : ''} />
              {canSeeClear && <div className="media-stats"><span>{p.views || 0} views</span><span>{typeof p.likes === 'object' ? p.likes?.length || 0 : p.likes || 0} likes</span></div>}
              {isSilver && <div className="lock-overlay">🔒</div>}
            </div>
          ))}
        </div>

        {/* Enlarged Photo Modal with Gallery Navigation */}
        {selected && (
          <div className="modal-overlay" onClick={() => { setSelected(null); setSelectedIdx(-1); }}>
            <div className="post-detail-modal" onClick={e => e.stopPropagation()} style={{position:'relative',maxWidth:560}}>
              {/* Gallery Nav Arrows */}
              {selectedIdx > 0 && <button onClick={goPrev} style={{position:'absolute',left:-50,top:'40%',background:'rgba(255,255,255,0.15)',border:'none',color:'#fff',fontSize:28,width:40,height:40,borderRadius:'50%',cursor:'pointer',zIndex:10}}>‹</button>}
              {selectedIdx < photos.length - 1 && <button onClick={goNext} style={{position:'absolute',right:-50,top:'40%',background:'rgba(255,255,255,0.15)',border:'none',color:'#fff',fontSize:28,width:40,height:40,borderRadius:'50%',cursor:'pointer',zIndex:10}}>›</button>}

              <img src={selected.photo_url} alt="" className={isSilver ? 'blur' : ''} style={{width: '100%', borderRadius: 12, marginBottom: 16}} />
              
              {/* Counter */}
              <div style={{textAlign:'center',color:'#888',fontSize:13,marginBottom:8}}>{selectedIdx + 1} / {photos.length}</div>

              <div className="modal-info">
                {/* Poster info - Platinum only */}
                {canViewPoster && selected.user && (
                  <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:12,cursor:'pointer'}} onClick={() => navigate(`/user/${selected.user.id}`)}>
                    {selected.user.profile_photo && <img src={selected.user.profile_photo} alt="" style={{width:36,height:36,borderRadius:'50%',objectFit:'cover'}} />}
                    <div><strong style={{color:'#fff'}}>{selected.user.name}</strong>{selected.user.age && <span style={{color:'#888'}}>, {selected.user.age}</span>}</div>
                  </div>
                )}
                {!canViewPoster && !isSilver && (
                  <p style={{color:'#888',marginBottom:12,fontSize:'0.85rem'}}>Upgrade to Platinum to see who posted & visit their profile</p>
                )}

                {/* Like + Comment - Gold & Platinum */}
                <div className="media-interact">
                  {canLike ? (
                    <button className="like-btn" data-testid="media-like-btn" onClick={async () => {
                      try { await axios.post(`${API}/media/${selected.id}/like`, {}, { headers: { Authorization: `Bearer ${token}` } }); 
                      setSelected({...selected, likes: (selected.likes || 0) + 1, liked: true}); } catch(e) { alert(e.response?.data?.detail || 'Failed'); }
                    }}>{selected.liked ? '❤️' : '🤍'} {typeof selected.likes === 'object' ? selected.likes?.length || 0 : selected.likes || 0}</button>
                  ) : (
                    <p style={{color:'#888',fontSize:'0.85rem'}}>Upgrade to Gold to like</p>
                  )}
                </div>

                <div className="media-comments">
                  <h4>Comments ({selected.comments?.length || 0})</h4>
                  <div className="comments-list">
                    {(selected.comments || []).map((c, i) => (
                      <div key={i} className="comment"><strong>{c.user_name}</strong>: {c.comment || c.text}</div>
                    ))}
                  </div>
                  {canComment ? (
                    <div className="add-comment">
                      <input type="text" placeholder="Add a comment..." id="commentInput" data-testid="media-comment-input" />
                      <button data-testid="media-comment-post" onClick={async () => {
                        const text = document.getElementById('commentInput').value;
                        if (!text.trim()) return;
                        try { 
                          await axios.post(`${API}/media/${selected.id}/comment`, { comment: text }, { headers: { Authorization: `Bearer ${token}` } });
                          setSelected({...selected, comments: [...(selected.comments || []), { user_name: user.name, comment: text }]});
                          document.getElementById('commentInput').value = '';
                        } catch(e) { alert(e.response?.data?.detail || 'Failed'); }
                      }}>Post</button>
                    </div>
                  ) : (
                    <p style={{color:'#888',fontSize:'0.85rem',marginTop:8}}>Upgrade to Gold to comment</p>
                  )}
                </div>

                <div className="modal-actions" style={{display:'flex',gap:8,marginTop:12}}>
                  <button className="btn-cancel" onClick={() => { setSelected(null); setSelectedIdx(-1); }}>Close</button>
                  {canViewPoster && selected.user && (<button className="btn-submit" onClick={() => navigate(`/user/${selected.user.id}`)}>View Profile</button>)}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

// PROFILE PAGE
const ProfilePage = () => {
  const { user, token, refreshUser } = useAuth();
  const [uploading, setUploading] = useState(false);
  const [privateAlbums, setPrivateAlbums] = useState([]);
  const [showCreateAlbum, setShowCreateAlbum] = useState(false);
  const [newAlbumName, setNewAlbumName] = useState('');
  const [selectedAlbum, setSelectedAlbum] = useState(null);
  const [activeTab, setActiveTab] = useState('public');
  const [stats, setStats] = useState({ views: 0, likes: 0, matches: 0, unread_messages: 0, unread_notifications: 0, album_requests: 0 });
  const [desires, setDesires] = useState([]);
  const [showDesires, setShowDesires] = useState(false);
  const [friendRequests, setFriendRequests] = useState([]);
  const [selectedViewPhoto, setSelectedViewPhoto] = useState(null);
  const profileRef = useRef(null);
  const galleryRef = useRef(null);
  const privateRef = useRef(null);
  const navigate = useNavigate();

  const fetchFriendRequests = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/friends/requests`, { headers: { Authorization: `Bearer ${token}` } });
      setFriendRequests(res.data.requests || []);
    } catch (e) {}
  }, [token]);

  const acceptFriend = async (reqId) => {
    try {
      await axios.post(`${API}/friends/accept/${reqId}`, {}, { headers: { Authorization: `Bearer ${token}` } });
      fetchFriendRequests();
      refreshUser();
    } catch (e) { alert('Failed'); }
  };

  const rejectFriend = async (reqId) => {
    try {
      await axios.post(`${API}/friends/reject/${reqId}`, {}, { headers: { Authorization: `Bearer ${token}` } });
      fetchFriendRequests();
    } catch (e) { alert('Failed'); }
  };

  const fetchStats = useCallback(async () => {
  if (!token) return;
  try {
    const res = await axios.get(`${API}/profile/stats`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    setStats(res.data);
  } catch (e) {
    console.log("Stats:", e.message);
  }
}, [token]);

const fetchPrivateAlbums = useCallback(async () => {
  if (!token) return;
  try {
    const res = await axios.get(`${API}/albums/private`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    setPrivateAlbums(res.data.albums || []);
  } catch (e) {
    console.log("Albums:", e.message);
  }
}, [token]);

useEffect(() => {
  fetchPrivateAlbums();
  fetchStats();
  fetchFriendRequests();
  setDesires(user?.desires || []);
}, [user, fetchPrivateAlbums, fetchStats, fetchFriendRequests]);

  const toggleDesire = (desire) => {
    const newDesires = desires.includes(desire) ? desires.filter(d => d !== desire) : [...desires, desire];
    setDesires(newDesires);
  };

  const saveDesires = async () => {
    try {
      await axios.put(`${API}/profile/desires`, desires, { headers: { Authorization: `Bearer ${token}` } });
      setShowDesires(false);
      refreshUser();
    } catch (e) { alert('Failed to save'); }
  };

  const handleUpload = async (e, isProfile) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      // Compress image: profile=800px, gallery=1200px for better quality
      const maxWidth = isProfile ? 800 : 1200;
      const compressed = await compressImage(file, maxWidth, 0.75);
      await axios.post(`${API}/upload/photo?is_profile=${isProfile}`, { image_data: compressed }, { headers: { Authorization: `Bearer ${token}` } });
      await refreshUser();
    } catch (err) {
      console.error('Upload error:', err);
      alert('Upload failed');
    }
    setUploading(false);
  };

  const handlePrivateUpload = async (e, albumId) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      // Compress private album photos
      const compressed = await compressImage(file, 1200, 0.75);
      await axios.post(`${API}/albums/private/${albumId}/photo`, { image_data: compressed }, { headers: { Authorization: `Bearer ${token}` } });
      fetchPrivateAlbums();
      if (selectedAlbum?.id === albumId) {
        const res = await axios.get(`${API}/albums/private/${albumId}`, { headers: { Authorization: `Bearer ${token}` } });
        setSelectedAlbum(res.data.album);
      }
    } catch (err) {
      console.error('Upload error:', err);
      alert('Upload failed');
    }
    setUploading(false);
  };

  const deletePhoto = async (url) => {
    try {
      await axios.delete(`${API}/photos/${encodeURIComponent(url)}`, { headers: { Authorization: `Bearer ${token}` } });
      await refreshUser();
    } catch (e) { alert('Delete failed'); }
  };

  const createAlbum = async () => {
    if (!newAlbumName.trim()) return;
    try {
      await axios.post(`${API}/albums/private`, { name: newAlbumName }, { headers: { Authorization: `Bearer ${token}` } });
      setNewAlbumName('');
      setShowCreateAlbum(false);
      fetchPrivateAlbums();
    } catch (e) { alert('Failed to create album'); }
  };

  const deleteAlbum = async (albumId) => {
    if (!window.confirm('Delete this album and all photos?')) return;
    try {
      await axios.delete(`${API}/albums/private/${albumId}`, { headers: { Authorization: `Bearer ${token}` } });
      setSelectedAlbum(null);
      fetchPrivateAlbums();
    } catch (e) { alert('Delete failed'); }
  };

  const openAlbum = async (album) => {
    try {
      const res = await axios.get(`${API}/albums/private/${album.id}`, { headers: { Authorization: `Bearer ${token}` } });
      setSelectedAlbum(res.data.album);
    } catch (e) { alert('Failed to open album'); }
  };

  const removePrivatePhoto = async (albumId, photoUrl) => {
    try {
      await axios.delete(`${API}/albums/private/${albumId}/photo?photo_url=${encodeURIComponent(photoUrl)}`, { headers: { Authorization: `Bearer ${token}` } });
      fetchPrivateAlbums();
      const res = await axios.get(`${API}/albums/private/${albumId}`, { headers: { Authorization: `Bearer ${token}` } });
      setSelectedAlbum(res.data.album);
    } catch (e) { alert('Failed to remove photo'); }
  };

  const grantAccess = async (albumId, userId) => {
    try {
      await axios.post(`${API}/albums/private/${albumId}/grant/${userId}`, {}, { headers: { Authorization: `Bearer ${token}` } });
      fetchPrivateAlbums();
      openAlbum({ id: albumId });
    } catch (e) { alert('Failed'); }
  };

  const denyAccess = async (albumId, userId) => {
    try {
      await axios.post(`${API}/albums/private/${albumId}/deny/${userId}`, {}, { headers: { Authorization: `Bearer ${token}` } });
      fetchPrivateAlbums();
      openAlbum({ id: albumId });
    } catch (e) { alert('Failed'); }
  };

  const revokeAccess = async (albumId, userId) => {
    try {
      await axios.post(`${API}/albums/private/${albumId}/revoke/${userId}`, {}, { headers: { Authorization: `Bearer ${token}` } });
      fetchPrivateAlbums();
      openAlbum({ id: albumId });
    } catch (e) { alert('Failed'); }
  };

  if (!user) return <div className="loading-screen"><div className="spinner"></div></div>;

  return (
    <div className="page-wrap">
      <Nav />
      <div className="profile-page mobile-friendly">
        {/* Homebase Activity Stats */}
        <div className="profile-homebase">
          <div className={`homebase-stat ${stats.views > 0 ? 'has-new' : ''}`} onClick={() => navigate('/activity/views')}>
            <div className="stat-icon">👁️</div>
            <span className="stat-num">{stats.views}</span>
            <span className="stat-label">Views</span>
          </div>
          <div className={`homebase-stat ${stats.likes > 0 ? 'has-new' : ''}`} onClick={() => navigate('/activity/likes')}>
            <div className="stat-icon">❤️</div>
            <span className="stat-num">{stats.likes}</span>
            <span className="stat-label">Likes</span>
          </div>
          <div className={`homebase-stat ${stats.unread_messages > 0 ? 'has-new' : ''}`} onClick={() => navigate('/inbox')}>
            <div className="stat-icon">💬</div>
            <span className="stat-num">{stats.unread_messages}</span>
            <span className="stat-label">Messages</span>
          </div>
          <div className={`homebase-stat ${stats.matches > 0 ? 'has-new' : ''}`} onClick={() => navigate('/matches')}>
            <div className="stat-icon">🔥</div>
            <span className="stat-num">{stats.matches}</span>
            <span className="stat-label">Matches</span>
          </div>
        </div>

        <div className="profile-header">
          <div className="avatar-wrap">
            <div className="avatar">
              {user.profile_photo ? <img src={user.profile_photo} alt="" /> : <span>{user.gender === 'female' ? '👩' : '👨'}</span>}
              {user.is_verified && <div className="ver-badge">✓</div>}
            </div>
            <button className="change-btn" onClick={() => profileRef.current?.click()} disabled={uploading}>📷</button>
            <input ref={profileRef} type="file" accept="image/*" onChange={e => handleUpload(e, true)} hidden />
          </div>
          <div className="header-info">
            <h1>{user.name}, {user.age} {user.verified_status === 'verified' && <span className="verified-badge">ID Verified</span>}</h1>
            <p className="type">{user.profile_type?.replace(/_/g, ' ')}</p>
            <p className="loc">📍 {user.location?.city}</p>
            <p className="membership-num">Membership #: {user.membership_number || user.membershipNumber || user.memberNumber || user.id?.slice(0,8).toUpperCase()}</p>
            <div className="profile-badges">
              <span className={`membership-badge ${user.membership_tier}`}>{user.membership_tier?.toUpperCase()}</span>
              {user.is_early_access && <span className="early-access-tag">Early Access</span>}
            </div>
            {user.gold_reason && user.membership_tier === 'gold' && (
              <p className="gold-reason">
                {user.gold_reason === 'female_default' ? '👑 Gold (Women\'s Perk)' : '🎉 Gold (Early Access)'}
              </p>
            )}
          </div>
        </div>

        <div className="profile-stats">
          <div><strong>{user.coins || 0}</strong><span>Coins</span></div>
          <div><strong>{(user.matches?.length || 0) + (user.friends?.length || 0)}</strong><span>Connections</span></div>
          <div><strong>{user.photos?.length || 0}</strong><span>Photos</span></div>
        </div>

        {/* Friend Requests */}
        {friendRequests.length > 0 && (
          <div className="profile-box friend-requests-box">
            <h3>FRIEND REQUESTS ({friendRequests.length})</h3>
            <div className="friend-requests-list">
              {friendRequests.map(r => (
                <div key={r.id} className="friend-request-item">
                  <div className="fr-info" onClick={() => navigate(`/user/${r.from_user_id}`)}>
                    <img src={r.from_user_photo || ''} alt="" />
                    <span>{r.from_user_name}</span>
                  </div>
                  <div className="fr-actions">
                    <button className="accept-btn" onClick={() => acceptFriend(r.id)}>Accept</button>
                    <button className="reject-btn" onClick={() => rejectFriend(r.id)}>Reject</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Matches & Friends Section */}
        <div className="profile-box connections-box">
          <h3>MATCHES & FRIENDS</h3>
          {(user.matches?.length > 0 || user.friends?.length > 0) ? (
            <div className="connections-grid">
              {[...(user.matches || []), ...(user.friends || [])].slice(0, 12).map((m, i) => (
                <div key={i} className="connection-thumb" onClick={() => navigate(`/user/${m.id || m}`)}>
                  {m.profile_photo ? <img src={m.profile_photo} alt="" /> : <span>👤</span>}
                </div>
              ))}
            </div>
          ) : (
            <p className="empty-text">No connections yet. Start swiping!</p>
          )}
          <button className="view-all-btn" onClick={() => navigate('/matches')}>View All</button>
        </div>

        <div className="profile-box">
          <h3>ABOUT ME</h3>
          <p>{user.bio || 'No bio yet'}</p>
        </div>

        <div className="profile-box">
          <h3>LOOKING FOR</h3>
          <div className="tags">{user.looking_for?.map(t => <span key={t}>{t.replace(/_/g, ' ')}</span>)}</div>
        </div>

        <div className="profile-box">
          <h3>SEEKING</h3>
          <div className="tags">{user.seeking?.map(t => <span key={t}>{t.replace(/_/g, ' ')}</span>)}</div>
        </div>

        <div className="profile-box">
          <h3>INTERESTS</h3>
          <div className="tags">{user.interests?.map(t => <span key={t}>{t.replace(/_/g, ' ')}</span>)}</div>
        </div>

        {/* Desires/Kinks */}
        <div className="profile-box">
          <h3>🔥 DESIRES</h3>
          {desires.length === 0 ? (
            <p className="empty">Add your desires under Settings → Edit Profile</p>
          ) : (
            <div className="tags">{desires.map(d => <span key={d}>{d}</span>)}</div>
          )}
        </div>

        {/* Album Tabs */}
        <div className="album-tabs">
          <button className={activeTab === 'display' ? 'active' : ''} onClick={() => setActiveTab('display')}>
            🖼️ Display Pics
          </button>
          <button className={activeTab === 'public' ? 'active' : ''} onClick={() => setActiveTab('public')}>
            📸 Public Gallery
          </button>
          <button className={activeTab === 'private' ? 'active' : ''} onClick={() => setActiveTab('private')}>
            🔒 Private Albums
          </button>
        </div>

        {/* Display Pics - shown on MeetPage cards */}
        {activeTab === 'display' && (
          <div className="profile-box gallery">
            <div className="box-head">
              <h3>DISPLAY PICS ({Math.min(3, user.photos?.length || 0)}/3)</h3>
            </div>
            <p className="album-hint">Your first 3 public photos are shown on your Meet card when someone taps it. Upload public photos to update these.</p>
            <div className="gallery-grid">
              {(user.photos || []).slice(0, 3).length === 0 ? <p className="empty">Upload public photos - your first 3 become display pics</p> : (user.photos || []).slice(0, 3).map((p, i) => (
                <div key={i} className="gal-item">
                  <img src={p} alt="" style={{cursor:'pointer'}} onClick={() => setSelectedViewPhoto(p)} />
                  <span style={{position:'absolute',top:4,left:4,background:'rgba(0,0,0,0.7)',color:'#14b8a6',padding:'2px 8px',borderRadius:10,fontSize:11}}>#{i+1}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Public Gallery */}
        {activeTab === 'public' && (
          <div className="profile-box gallery">
            <div className="box-head">
              <h3>PUBLIC GALLERY ({user.photos?.length || 0})</h3>
              <button onClick={() => galleryRef.current?.click()} disabled={uploading}>+ Add Photo</button>
              <input ref={galleryRef} type="file" accept="image/*" onChange={e => handleUpload(e, false)} hidden />
            </div>
            <p className="album-hint">These photos are visible to all members based on their tier</p>
            <div className="gallery-grid">
              {user.photos?.length === 0 ? <p className="empty">No photos yet</p> : user.photos?.map((p, i) => (
                <div key={i} className="gal-item">
                  <img src={p} alt="" style={{cursor:'pointer'}} onClick={() => setSelectedViewPhoto(p)} />
                  <button onClick={() => deletePhoto(p)}>✕</button>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Private Albums */}
        {activeTab === 'private' && (
          <div className="profile-box private-albums">
            <div className="box-head">
              <h3>🔒 PRIVATE ALBUMS ({privateAlbums.length})</h3>
              <button onClick={() => setShowCreateAlbum(true)}>+ New Album</button>
            </div>
            <p className="album-hint">Only users you invite can view these photos</p>
            
            {showCreateAlbum && (
              <div className="create-album-form">
                <input 
                  type="text" 
                  placeholder="Album name..." 
                  value={newAlbumName} 
                  onChange={e => setNewAlbumName(e.target.value)}
                  maxLength={50}
                />
                <div className="form-actions">
                  <button onClick={createAlbum} disabled={!newAlbumName.trim()}>Create</button>
                  <button className="cancel" onClick={() => { setShowCreateAlbum(false); setNewAlbumName(''); }}>Cancel</button>
                </div>
              </div>
            )}

            <div className="albums-grid">
              {privateAlbums.length === 0 ? (
                <p className="empty">No private albums yet. Create one to share exclusive photos with selected members.</p>
              ) : privateAlbums.map(album => (
                <div key={album.id} className="album-card" onClick={() => openAlbum(album)}>
                  <div className="album-cover">
                    {album.photos?.[0] ? <img src={album.photos[0].url} alt="" /> : <span>🔒</span>}
                  </div>
                  <div className="album-info">
                    <h4>{album.name}</h4>
                    <span>{album.photos?.length || 0} photos</span>
                    <span>{album.invited_users?.length || 0} viewers</span>
                    {album.pending_requests?.length > 0 && (
                      <span className="pending-badge">{album.pending_requests.length} requests</span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Album Detail Modal */}
        {selectedAlbum && (
          <div className="modal album-modal" onClick={() => setSelectedAlbum(null)}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
              <div className="modal-header">
                <h3>🔒 {selectedAlbum.name}</h3>
                <button className="close" onClick={() => setSelectedAlbum(null)}>✕</button>
              </div>
              
              <div className="album-actions">
                <button onClick={() => privateRef.current?.click()} disabled={uploading}>
                  📷 Add Photo
                </button>
                <input ref={privateRef} type="file" accept="image/*" onChange={e => handlePrivateUpload(e, selectedAlbum.id)} hidden />
                <button className="danger" onClick={() => deleteAlbum(selectedAlbum.id)}>🗑️ Delete Album</button>
              </div>

              {/* Pending Requests */}
              {selectedAlbum.pending_requests?.length > 0 && (
                <div className="access-section">
                  <h4>⏳ Access Requests</h4>
                  <div className="access-list">
                    {selectedAlbum.pending_requests.map(userId => (
                      <div key={userId} className="access-item">
                        <span>User {userId.slice(0, 8)}...</span>
                        <button className="grant" onClick={() => grantAccess(selectedAlbum.id, userId)}>✓ Grant</button>
                        <button className="deny" onClick={() => denyAccess(selectedAlbum.id, userId)}>✕ Deny</button>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Current Viewers */}
              {selectedAlbum.invited_users?.length > 0 && (
                <div className="access-section">
                  <h4>👁️ Can View ({selectedAlbum.invited_users.length})</h4>
                  <div className="access-list">
                    {selectedAlbum.invited_users.map(userId => (
                      <div key={userId} className="access-item">
                        <span>User {userId.slice(0, 8)}...</span>
                        <button className="revoke" onClick={() => revokeAccess(selectedAlbum.id, userId)}>Revoke</button>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Photos */}
              <div className="album-photos">
                {selectedAlbum.photos?.length === 0 ? (
                  <p className="empty">No photos in this album yet</p>
                ) : (
                  <div className="gallery-grid">
                    {selectedAlbum.photos?.map((p, i) => (
                      <div key={i} className="gal-item">
                        <img src={p.url} alt="" />
                        <button onClick={() => removePrivatePhoto(selectedAlbum.id, p.url)}>✕</button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        <div className="profile-actions">
          <button onClick={() => navigate('/membership')}>⭐ Upgrade</button>
          <button onClick={() => navigate('/store')}>🛒 Store</button>
          <button onClick={() => navigate('/settings')}>⚙️ Settings</button>
        </div>

        {/* Photo Viewer */}
        {selectedViewPhoto && (
          <div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.92)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}} onClick={() => setSelectedViewPhoto(null)}>
            <div onClick={e => e.stopPropagation()} style={{textAlign:'center',maxWidth:'90vw'}}>
              <img src={selectedViewPhoto} alt="" style={{maxWidth:'90vw',maxHeight:'70vh',objectFit:'contain',borderRadius:8}} />
              <div style={{marginTop:12,display:'flex',gap:8,justifyContent:'center',alignItems:'center',flexWrap:'wrap'}}>
                <button onClick={async () => {
                  try { await axios.post(`${API}/photos/like`, { photo_url: selectedViewPhoto, user_id: user.id }, { headers: { Authorization: `Bearer ${token}` } }); alert('Liked!'); } catch(e){ alert(e.response?.data?.detail || 'Failed'); }
                }} style={{background:'rgba(255,255,255,0.1)',border:'none',padding:'8px 16px',borderRadius:8,cursor:'pointer',fontSize:16,color:'#f87171'}}>❤️ Like</button>
              </div>
              <button onClick={() => setSelectedViewPhoto(null)} style={{display:'block',margin:'12px auto',background:'#333',color:'#fff',border:'none',padding:'8px 24px',borderRadius:8,cursor:'pointer'}}>Close</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

// MEMBERSHIP PAGE
const MembershipPage = () => {
  const { token, user, refreshUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [showPayment, setShowPayment] = useState(false);
  const [selectedTier, setSelectedTier] = useState(null);
  const [requestSent, setRequestSent] = useState(false);

  const bankDetails = {
    bankName: "FNB",
    accountType: "Cheque Account",
    accountName: "FWB SA",
    accountNumber: "6253 6119 200",
    reference: user?.membership_number || user?.id?.slice(0,8).toUpperCase()
  };

  const tierData = [
    { key: 'silver', name: 'Free', price: 0, priceDisplay: 'FREE', features: ['Limited swipes', 'Basic messaging', 'View blurred profiles', 'Standard support'] },
    { key: 'gold', name: 'Gold', price: 249, priceDisplay: 'R249', features: ['More swipes', 'Full messaging', 'View clear profiles', 'See who viewed you', 'Incognito mode', 'Priority support'], popular: true },
    { key: 'platinum', name: 'Platinum', price: 399, priceDisplay: 'R399', features: ['Unlimited swipes', 'Unlimited messages', 'All Gold features', 'See who liked you', 'Access private albums', 'VIP support', 'Priority matching'] }
  ];

  const selectPlan = (tier) => {
    if (tier.key === 'silver' || tier.key === user?.membership_tier) return;
    setSelectedTier(tier);
    setShowPayment(true);
    setRequestSent(false);
  };

  const submitRequest = async () => {
    setLoading(true);
    try {
      await axios.post(`${API}/payment/request-upgrade`, { tier: selectedTier.key, amount: selectedTier.price }, { headers: { Authorization: `Bearer ${token}` } });
      setRequestSent(true);
    } catch (e) { alert(e.response?.data?.detail || 'Failed to submit request'); }
    setLoading(false);
  };

  return (
    <div className="page-wrap">
      <Nav />
      <div className="membership-page mobile-friendly">
        <h1>Membership Plans</h1>
        <p className="page-desc">Unlock your full experience</p>

        {/* Payment Process Info */}
        <div className="payment-info-box">
          <h3>💳 How Payment Works</h3>
          <ol>
            <li>Select your desired membership plan below</li>
            <li>Make an EFT payment to our bank account using your membership number as reference</li>
            <li>Your request will be sent to admin for approval</li>
            <li>Once payment is verified, your membership will be upgraded immediately</li>
          </ol>
        </div>

        {user?.gold_reason && user?.membership_tier === 'gold' && (
          <div className="gold-perk-banner">
            <span>🎉</span>
            <p>{user.gold_reason === 'female_default' ? 'You have Gold as a Women\'s Perk!' : 'You have Gold as an Early Access member!'}</p>
          </div>
        )}

        <div className="tiers-grid">
          {tierData.map(t => {
            const current = user?.membership_tier === t.key;
            return (
              <div key={t.key} className={`tier-card ${t.key} ${current ? 'current' : ''}`}>
                {t.popular && <div className="pop-tag">MOST POPULAR</div>}
                <div className="tier-head">
                  <h3>{t.name}</h3>
                  <div className="price">{t.priceDisplay}{t.priceDisplay !== 'FREE' && <span>/mo</span>}</div>
                </div>
                <ul>{t.features.map((f, i) => <li key={i}>✓ {f}</li>)}</ul>
                {current ? <button className="btn-cur" disabled>Current Plan</button> : t.priceDisplay !== 'FREE' && (
                  <button className="btn-up" onClick={() => selectPlan(t)} disabled={loading}>
                    Select Plan
                  </button>
                )}
              </div>
            );
          })}
        </div>

        {/* Payment Modal */}
        {showPayment && selectedTier && (
          <div className="modal-overlay" onClick={() => setShowPayment(false)}>
            <div className="payment-modal" onClick={e => e.stopPropagation()}>
              {!requestSent ? (
                <>
                  <h2>Upgrade to {selectedTier.name}</h2>
                  <p className="payment-amount">Amount: <strong>R{selectedTier.price}</strong></p>
                  
                  <div className="bank-details-box">
                    <h3>Bank Details for EFT Payment</h3>
                    <div className="bank-row"><span>Bank:</span><strong>{bankDetails.bankName}</strong></div>
                    <div className="bank-row"><span>Account Name:</span><strong>{bankDetails.accountName}</strong></div>
                    <div className="bank-row"><span>Account Number:</span><strong>{bankDetails.accountNumber}</strong></div>
                                        <div className="bank-row reference"><span>Reference:</span><strong>{bankDetails.reference}</strong></div>
                  </div>
                  
                  <p className="payment-note">⚠️ Use your membership number <strong>{bankDetails.reference}</strong> as payment reference for faster processing.</p>
                  
                  <div className="modal-actions">
                    <button className="btn-cancel" onClick={() => setShowPayment(false)}>Cancel</button>
                    <button className="btn-submit" onClick={submitRequest} disabled={loading}>
                      {loading ? 'Submitting...' : 'I Have Paid - Submit Request'}
                    </button>
                  </div>
                </>
              ) : (
                <div className="request-success">
                  <span className="success-icon">✅</span>
                  <h2>Request Submitted!</h2>
                  <p>Your upgrade request has been sent to admin for approval.</p>
                  <p>Once your payment of <strong>R{selectedTier.price}</strong> is verified, your membership will be upgraded to <strong>{selectedTier.name}</strong>.</p>
                  <button className="btn-submit" onClick={() => setShowPayment(false)}>Close</button>
                </div>
              )}
            </div>
          </div>
        )}

        <p className="membership-footer">Your membership number: <strong>{user?.membership_number || 'N/A'}</strong></p>
      </div>
    </div>
  );
};

// STORE PAGE
const StorePage = () => {
  const { token, user, refreshUser, config } = useAuth();
  const [tab, setTab] = useState('buy');
  const [loading, setLoading] = useState(false);
  const [showPayment, setShowPayment] = useState(false);
  const [selectedBundle, setSelectedBundle] = useState(null);
  const [requestSent, setRequestSent] = useState(false);

  const bundles = config?.coin_bundles || [];
  const items = config?.store_items || [];

  const bankDetails = {
    bankName: "FNB",
    accountType: "Cheque Account",
    accountName: "FWB SA",
    accountNumber: "6253 6119 200",
    reference: user?.membership_number || user?.id?.slice(0,8).toUpperCase()
  };

  const selectBundle = (bundle) => {
    setSelectedBundle(bundle);
    setShowPayment(true);
    setRequestSent(false);
  };

  const submitCoinRequest = async () => {
    setLoading(true);
    try {
      await axios.post(`${API}/payment/request-coins`, { bundle_id: selectedBundle.id, coins: selectedBundle.coins, amount: selectedBundle.price }, { headers: { Authorization: `Bearer ${token}` } });
      setRequestSent(true);
    } catch (e) { alert(e.response?.data?.detail || 'Failed to submit request'); }
    setLoading(false);
  };

  const buyItem = async (id) => {
    setLoading(true);
    try {
      await axios.post(`${API}/store/buy-item?item_id=${id}`, {}, { headers: { Authorization: `Bearer ${token}` } });
      await refreshUser();
      alert('Purchased!');
    } catch (e) { alert(e.response?.data?.detail || 'Failed'); }
    setLoading(false);
  };

  return (
    <div className="page-wrap">
      <Nav />
      <div className="store-page">
        <h1>Store</h1>
        <p className="page-desc">Your coins: <strong>{user?.coins || 0}</strong> 🪙</p>
        <div className="coins-display">🪙 <strong>{user?.coins || 0}</strong> Coins</div>

        <div className="store-tabs">
          <button className={tab === 'buy' ? 'active' : ''} onClick={() => setTab('buy')}>Buy Coins</button>
          <button className={tab === 'spend' ? 'active' : ''} onClick={() => setTab('spend')}>Spend Coins</button>
        </div>

        {/* Payment Info */}
        <div className="payment-info-box" style={{marginBottom: 20}}>
          <h3>💳 How to Buy Coins</h3>
          <ol>
            <li>Select a coin bundle below</li>
            <li>Make EFT payment to our bank with your membership number as reference</li>
            <li>Submit your request - admin will verify and add coins to your account</li>
          </ol>
        </div>

        {tab === 'buy' ? (
          <div className="bundles">
            {bundles.map(b => (
              <div key={b.id} className={`bundle ${b.popular ? 'pop' : ''}`}>
                {b.popular && <div className="best">BEST VALUE</div>}
                <div className="coins">{b.coins}</div>
                {b.bonus > 0 && <div className="bonus">+{b.bonus} bonus</div>}
                <div className="price">R{b.price}</div>
                <button onClick={() => selectBundle(b)} disabled={loading}>Select</button>
              </div>
            ))}
          </div>
        ) : (
          <div className="items">
            {items.map(i => (
              <div key={i.id} className="item">
                <h4>{i.name}</h4>
                <p>{i.description}</p>
                <div className="item-price">🪙 {i.coin_price}</div>
                <button onClick={() => buyItem(i.id)} disabled={loading || (user?.coins || 0) < i.coin_price}>
                  {(user?.coins || 0) < i.coin_price ? 'Need more' : 'Buy'}
                </button>
              </div>
            ))}
          </div>
        )}

        {/* Payment Modal for Coins */}
        {showPayment && selectedBundle && (
          <div className="modal-overlay" onClick={() => setShowPayment(false)}>
            <div className="payment-modal" onClick={e => e.stopPropagation()}>
              {!requestSent ? (
                <>
                  <h2>Buy {selectedBundle.coins} Coins</h2>
                  <p className="payment-amount">Amount: <strong>R{selectedBundle.price}</strong></p>
                  
                  <div className="bank-details-box">
                    <h3>Bank Details for EFT Payment</h3>
                    <div className="bank-row"><span>Bank:</span><strong>{bankDetails.bankName}</strong></div>
                    <div className="bank-row"><span>Account Name:</span><strong>{bankDetails.accountName}</strong></div>
                    <div className="bank-row"><span>Account Number:</span><strong>{bankDetails.accountNumber}</strong></div>
                                        <div className="bank-row reference"><span>Reference:</span><strong>{bankDetails.reference}</strong></div>
                  </div>
                  
                  <p className="payment-note">⚠️ Use your membership number <strong>{bankDetails.reference}</strong> as payment reference.</p>
                  
                  <div className="modal-actions">
                    <button className="btn-cancel" onClick={() => setShowPayment(false)}>Cancel</button>
                    <button className="btn-submit" onClick={submitCoinRequest} disabled={loading}>
                      {loading ? 'Submitting...' : 'I Have Paid - Submit Request'}
                    </button>
                  </div>
                </>
              ) : (
                <div className="request-success">
                  <span className="success-icon">✅</span>
                  <h2>Request Submitted!</h2>
                  <p>Your coin purchase request has been sent to admin.</p>
                  <p>Once payment of <strong>R{selectedBundle.price}</strong> is verified, <strong>{selectedBundle.coins} coins</strong> will be added to your account.</p>
                  <button className="btn-submit" onClick={() => setShowPayment(false)}>Close</button>
                </div>
              )}
            </div>
          </div>
        )}

        <p className="membership-footer">Your membership number: <strong>{user?.membership_number || 'N/A'}</strong></p>
      </div>
    </div>
  );
};

// OTHER PAGES (Matches, Messages, Chat, UserProfile, Activity, Winks, Events)
// INBOX PAGE - Combined Matches + Messages
const InboxPage = () => {
  const { token, user } = useAuth();
  const [matches, setMatches] = useState([]);
  const [convos, setConvos] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const tier = user?.membership_tier || 'silver';
  const isAdmin = user?.email === 'admin@fwbsa.co.za' || user?.role === 'admin' || user?.role === 'owner';
  const isSilver = tier === 'silver' && !isAdmin;
  const canSee = tier === 'gold' || tier === 'platinum' || isAdmin;

  useEffect(() => {
    Promise.all([
      axios.get(`${API}/matches`, { headers: { Authorization: `Bearer ${token}` } }),
      axios.get(`${API}/messages/conversations`, { headers: { Authorization: `Bearer ${token}` } })
    ]).then(([m, c]) => {
      setMatches(m.data || []);
      setConvos(c.data || []);
    }).finally(() => setLoading(false));
  }, [token]);

  if (loading) return <div className="page-wrap"><Nav /><div className="loading-screen"><div className="spinner"></div></div></div>;

  return (
    <div className="page-wrap">
      <Nav />
      <div className="inbox-page">
        <h1>Inbox</h1>

        {/* Upgrade prompt for Silver */}
        {isSilver && (
          <div className="tier-block">
            <p>🔥 Upgrade your membership to see who matched with you and read messages</p>
            <button onClick={() => navigate('/membership')}>Upgrade Now</button>
          </div>
        )}

        {/* Matches Row - Horizontal scroll */}
        <section className="inbox-section">
          <h2>Matches ({matches.length})</h2>
          <div className="matches-row">
            {matches.length === 0 ? <p className="empty">No matches yet. Start swiping!</p> : matches.map(m => (
              <div key={m.id} className={`match-thumb ${isSilver ? 'locked' : ''}`} onClick={() => canSee ? navigate(`/messages/${m.id}`) : navigate('/membership')}>
                <div className="mt-img">
                  {m.profile_photo ? <img src={m.profile_photo} alt="" className={isSilver ? 'blur' : ''} /> : '👤'}
                  {m.is_online && <div className="online-dot"></div>}
                </div>
                <span className="mt-name">{canSee ? m.name : '•••'}</span>
                {isSilver && <div className="lock-overlay sm">🔒</div>}
              </div>
            ))}
          </div>
        </section>

        {/* Messages List */}
        <section className="inbox-section">
          <h2>Messages</h2>
          <div className="messages-list">
            {convos.length === 0 ? <p className="empty">No messages yet. Match with someone to start chatting!</p> : convos.map(c => (
              <div key={c.partner_id} className={`message-item ${isSilver ? 'locked' : ''}`} onClick={() => canSee ? navigate(`/messages/${c.partner_id}`) : navigate('/membership')}>
                <div className="mi-avatar">
                  {c.partner_photo ? <img src={c.partner_photo} alt="" className={isSilver ? 'blur' : ''} /> : '👤'}
                </div>
                <div className="mi-content">
                  <div className="mi-head">
                    <span className="mi-name">{canSee ? c.partner_name : '•••••'}</span>
                    <span className="mi-time">{c.time_ago || 'Just now'}</span>
                  </div>
                  <p className="mi-preview">{canSee ? c.last_message : '••••••••••••••••••'}</p>
                </div>
                {c.unread > 0 && <span className="unread-badge">{c.unread}</span>}
                {isSilver && <div className="lock-overlay sm">🔒</div>}
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

// Legacy pages redirect to Inbox
const MatchesPage = () => <Navigate to="/inbox" />;
const MessagesPage = () => <Navigate to="/inbox" />;

const ChatPage = () => {
  const { id } = useParams();
  const { token, user } = useAuth();
  const [msgs, setMsgs] = useState([]);
  const [txt, setTxt] = useState("");
  const [partner, setPartner] = useState(null);
  const endRef = useRef(null);

  useEffect(() => {
    Promise.all([
      axios.get(`${API}/messages/${id}`, { headers: { Authorization: `Bearer ${token}` } }),
      axios.get(`${API}/profile/${id}`, { headers: { Authorization: `Bearer ${token}` } })
    ]).then(([m, p]) => { setMsgs(m.data); setPartner(p.data); });
  }, [id, token]);

  useEffect(() => { endRef.current?.scrollIntoView({ behavior: 'smooth' }); }, [msgs]);

  const send = async () => {
    if (!txt.trim()) return;
    try {
      await axios.post(`${API}/messages`, { to_user_id: id, content: txt }, { headers: { Authorization: `Bearer ${token}` } });
      setMsgs([...msgs, { from_user_id: user.id, content: txt, created_at: new Date().toISOString() }]);
      setTxt("");
    } catch (e) { alert(e.response?.data?.detail || 'Failed'); }
  };

  return (
    <div className="page-wrap">
      <Nav />
      <div className="chat-page">
        <div className="chat-head"><h2>Chat with {partner?.name}</h2></div>
        <div className="chat-msgs">
          {msgs.map((m, i) => <div key={i} className={`msg ${m.from_user_id === user?.id ? 'sent' : 'recv'}`}><p>{m.content}</p></div>)}
          <div ref={endRef} />
        </div>
        <div className="chat-input">
          <input value={txt} onChange={e => setTxt(e.target.value)} placeholder="Type..." onKeyPress={e => e.key === 'Enter' && send()} />
          <button onClick={send}>Send</button>
        </div>
      </div>
    </div>
  );
};

const UserProfilePage = () => {
  const { id } = useParams();
  const { token, user } = useAuth();
  const [profile, setProfile] = useState(null);
  const [isFriend, setIsFriend] = useState(false);
  const [requestSent, setRequestSent] = useState(false);
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [photoComment, setPhotoComment] = useState('');
  const [photoLiked, setPhotoLiked] = useState(false);
  const navigate = useNavigate();

  const isAdmin = user?.email === 'admin@fwbsa.co.za' || user?.role === 'owner' || user?.role === 'admin';
  const canSee = user?.membership_tier === 'gold' || user?.membership_tier === 'platinum' || isAdmin;
  const canLike = user?.membership_tier === 'gold' || user?.membership_tier === 'platinum' || isAdmin;
  const canComment = user?.membership_tier === 'gold' || user?.membership_tier === 'platinum' || isAdmin;
  const canViewPoster = user?.membership_tier === 'platinum' || isAdmin;

  useEffect(() => { 
    axios.get(`${API}/profile/${id}`, { headers: { Authorization: `Bearer ${token}` } }).then(r => {
      setProfile(r.data);
      setIsFriend(user?.matches?.includes(id) || false);
    }); 
  }, [id, token, user]);

  const sendFriendRequest = async () => {
    try {
      await axios.post(`${API}/friends/request/${id}`, {}, { headers: { Authorization: `Bearer ${token}` } });
      setRequestSent(true);
      alert('Friend request sent!');
    } catch (e) { alert(e.response?.data?.detail || 'Failed to send request'); }
  };

  const blockUser = async () => {
    if (window.confirm(`Block ${profile?.name || 'this user'}? They won't be able to contact you.`)) {
      try {
        await axios.post(`${API}/users/${id}/block`, {}, { headers: { Authorization: `Bearer ${token}` } });
        alert('User blocked');
        navigate('/home');
      } catch (e) { alert('Failed to block user'); }
    }
  };

  const reportUser = async () => {
    const reason = window.prompt('Why are you reporting this user? (harassment, fake_profile, inappropriate_content, spam, other)');
    if (!reason) return;
    try {
      await axios.post(`${API}/users/report`, { reported_user_id: id, report_type: reason, description: reason }, { headers: { Authorization: `Bearer ${token}` } });
      alert('Report submitted. We will review it shortly.');
    } catch (e) { alert(e.response?.data?.detail || 'Failed to submit report'); }
  };

  if (!profile) return <div className="page-wrap"><Nav /><div className="loading-screen"><div className="spinner"></div></div></div>;

  return (
    <div className="page-wrap">
      <Nav />
      <div className="view-profile" style={{maxWidth:600,margin:'0 auto',padding:'16px'}}>
        <button onClick={() => navigate(-1)} style={{background:'none',border:'none',color:'#14b8a6',cursor:'pointer',fontSize:16,marginBottom:12}}>← Back</button>
        <div className="vp-card" style={{background:'#1a1a2e',borderRadius:16,padding:20,marginBottom:16}}>
          <div className="vp-avatar" style={{width:120,height:120,borderRadius:'50%',overflow:'hidden',margin:'0 auto 16px'}}>
            {profile.profile_photo ? <img src={profile.profile_photo} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}} className={!canSee ? 'blur' : ''} /> : <div style={{width:'100%',height:'100%',background:'#2a2a3e',display:'flex',alignItems:'center',justifyContent:'center',fontSize:48}}>👤</div>}
          </div>
          <h1 style={{textAlign:'center',color:'#fff',marginBottom:4}}>{canSee ? profile.name : '•••••'}, {profile.age}</h1>
          <p style={{textAlign:'center',color:'#14b8a6',marginBottom:4}}>{profile.profile_type?.replace(/_/g, ' ')}</p>
          <p style={{textAlign:'center',color:'#888',marginBottom:8}}>📍 {profile.location?.city || 'Unknown'}</p>
          {profile.membership_number && <p style={{textAlign:'center',color:'#666',fontSize:13,marginBottom:12}}>Member #{profile.membership_number}</p>}
          
          {canSee && (
            <>
              {profile.bio && <div style={{background:'#12121e',borderRadius:12,padding:14,marginBottom:12}}><h4 style={{color:'#14b8a6',marginBottom:6,fontSize:14}}>About</h4><p style={{color:'#ccc',lineHeight:1.6}}>{profile.bio}</p></div>}
              
              {profile.looking_for?.length > 0 && (
                <div style={{marginBottom:12}}>
                  <h4 style={{color:'#14b8a6',marginBottom:8,fontSize:14}}>Looking For</h4>
                  <div style={{display:'flex',flexWrap:'wrap',gap:6}}>{profile.looking_for.map(t => <span key={t} style={{background:'#2a2a3e',color:'#ccc',padding:'4px 10px',borderRadius:20,fontSize:13}}>{t.replace(/_/g,' ')}</span>)}</div>
                </div>
              )}
              
              {profile.interests?.length > 0 && (
                <div style={{marginBottom:12}}>
                  <h4 style={{color:'#14b8a6',marginBottom:8,fontSize:14}}>Interests</h4>
                  <div style={{display:'flex',flexWrap:'wrap',gap:6}}>{profile.interests.map(t => <span key={t} style={{background:'#2a2a3e',color:'#ccc',padding:'4px 10px',borderRadius:20,fontSize:13}}>{t}</span>)}</div>
                </div>
              )}
              
              {profile.photos?.length > 0 && (
                <div style={{marginBottom:12}}>
                  <h4 style={{color:'#14b8a6',marginBottom:8,fontSize:14}}>Photos ({profile.photos.length})</h4>
                  <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:8}}>
                    {profile.photos.map((photo, i) => (
                      <div key={i} style={{borderRadius:8,overflow:'hidden',aspectRatio:'1',cursor:'pointer'}} onClick={() => setSelectedPhoto(photo)}>
                        <img src={photo} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}} />
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div style={{display:'flex',gap:6,marginBottom:8,color:'#888',fontSize:13,justifyContent:'center'}}>
                <span>{profile.is_online ? '🟢 Online' : '⚪ Offline'}</span>
                {profile.is_verified && <span>✓ Verified</span>}
                <span className={`tier-${profile.membership_tier}`}>{profile.membership_tier?.toUpperCase()}</span>
              </div>
            </>
          )}
          
          <div className="vp-actions" style={{display:'flex',flexWrap:'wrap',gap:8,justifyContent:'center',marginTop:16}}>
            {!isFriend && !requestSent && <button className="friend-btn" data-testid="add-friend-btn" onClick={sendFriendRequest} style={{background:'#14b8a6',color:'#000',border:'none',padding:'10px 20px',borderRadius:8,cursor:'pointer',fontWeight:600}}>+ Add Friend</button>}
            {requestSent && <button disabled style={{background:'#333',color:'#888',border:'none',padding:'10px 20px',borderRadius:8}}>Request Sent</button>}
            {isFriend && <span style={{background:'#22c55e',color:'#fff',padding:'8px 16px',borderRadius:8}}>Friends</span>}
            <button onClick={() => navigate(`/messages/${id}`)} style={{background:'#2a2a3e',color:'#fff',border:'none',padding:'10px 20px',borderRadius:8,cursor:'pointer'}}>Message</button>
            <button data-testid="block-user-btn" onClick={blockUser} style={{background:'#333',color:'#f87171',border:'none',padding:'10px 16px',borderRadius:8,cursor:'pointer'}}>Block</button>
            <button data-testid="report-user-btn" onClick={reportUser} style={{background:'#dc2626',color:'#fff',border:'none',padding:'10px 16px',borderRadius:8,cursor:'pointer'}}>Report</button>
          </div>
          {!canSee && <div style={{textAlign:'center',marginTop:16,padding:16,background:'rgba(20,184,166,0.1)',borderRadius:12}}><p style={{color:'#14b8a6',marginBottom:8}}>🔒 Upgrade to view full profile</p><button onClick={() => navigate('/membership')} style={{background:'#14b8a6',color:'#000',border:'none',padding:'10px 24px',borderRadius:8,cursor:'pointer',fontWeight:600}}>Upgrade</button></div>}
        </div>

        {/* Photo Viewer Modal with Like/Comment */}
        {selectedPhoto && (
          <div className="modal-overlay" onClick={() => { setSelectedPhoto(null); setPhotoComment(''); setPhotoLiked(false); }} style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.92)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}}>
            <div onClick={e => e.stopPropagation()} style={{maxWidth:'90vw',maxHeight:'90vh',textAlign:'center'}}>
              <img src={selectedPhoto} alt="" style={{maxWidth:'90vw',maxHeight:'65vh',objectFit:'contain',borderRadius:8}} />
              <div style={{marginTop:12,display:'flex',gap:8,justifyContent:'center',alignItems:'center',flexWrap:'wrap'}}>
                <button onClick={async () => {
                  if (!canLike) { alert('Upgrade to Gold to like photos'); return; }
                  try { await axios.post(`${API}/photos/like`, { photo_url: selectedPhoto, user_id: id }, { headers: { Authorization: `Bearer ${token}` } }); setPhotoLiked(true); } catch(e){}
                }} style={{background: photoLiked ? '#f87171' : 'rgba(255,255,255,0.1)',border:'none',padding:'8px 16px',borderRadius:8,cursor:'pointer',fontSize:16,color: photoLiked ? '#fff' : '#f87171'}}>{photoLiked ? '❤️ Liked' : '♡ Like'}</button>
                {canComment && (
                  <div style={{display:'flex',gap:4}}>
                    <input value={photoComment} onChange={e => setPhotoComment(e.target.value)} placeholder="Comment..." style={{background:'#2a2a3e',border:'none',color:'#fff',padding:'8px 12px',borderRadius:8,fontSize:13,width:160}} onKeyDown={e => {
                      if (e.key === 'Enter' && photoComment.trim()) {
                        axios.post(`${API}/photos/comment`, { photo_url: selectedPhoto, user_id: id, comment: photoComment }, { headers: { Authorization: `Bearer ${token}` } }).then(() => { setPhotoComment(''); alert('Comment sent!'); }).catch(()=>{});
                      }
                    }} />
                    <button onClick={() => {
                      if (!photoComment.trim()) return;
                      axios.post(`${API}/photos/comment`, { photo_url: selectedPhoto, user_id: id, comment: photoComment }, { headers: { Authorization: `Bearer ${token}` } }).then(() => { setPhotoComment(''); alert('Comment sent!'); }).catch(()=>{});
                    }} style={{background:'#14b8a6',border:'none',color:'#000',padding:'8px 12px',borderRadius:8,cursor:'pointer',fontWeight:600}}>Send</button>
                  </div>
                )}
                {!canLike && <span style={{color:'#888',fontSize:12}}>Upgrade to Gold to like photos</span>}
                {canLike && !canComment && <span style={{color:'#888',fontSize:12}}>Upgrade to Platinum to comment</span>}
              </div>
              <button onClick={() => { setSelectedPhoto(null); setPhotoComment(''); setPhotoLiked(false); }} style={{display:'block',margin:'12px auto',background:'#333',color:'#fff',border:'none',padding:'8px 24px',borderRadius:8,cursor:'pointer'}}>Close</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const ActivityPage = ({ type }) => {
  const { token, user } = useAuth();
  const [data, setData] = useState({ locked: true, count: 0 });
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${API}/activity/${type}`, { headers: { Authorization: `Bearer ${token}` } }).then(r => setData(r.data));
  }, [token, type]);

  const isAdmin = user?.email === 'admin@fwbsa.co.za' || user?.role === 'owner' || user?.role === 'admin';
  const canSee = user?.membership_tier === 'gold' || user?.membership_tier === 'platinum' || isAdmin;

  return (
    <div className="page-wrap">
      <Nav />
      <div className="list-page">
        <h1>{type === 'views' ? 'Who Viewed You' : 'Who Liked You'}</h1>
        {!canSee || data.locked ? (
          <div className="locked-box">
            <p>🔒 {data.count} people {type === 'views' ? 'viewed' : 'liked'} you</p>
            <button onClick={() => navigate('/membership')}>Upgrade to See</button>
          </div>
        ) : (
          <div className="list">
            {(data.views || data.likes || []).map((v, i) => (
              <div key={i} className="list-item">
                <div className="li-avatar">👤</div>
                <div className="li-info"><h3>{v.viewer?.name || v.name}</h3></div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

const WinksPage = () => {
  const { token } = useAuth();
  const [winks, setWinks] = useState([]);
  const navigate = useNavigate();

  useEffect(() => { axios.get(`${API}/winks/received`, { headers: { Authorization: `Bearer ${token}` } }).then(r => setWinks(r.data)); }, [token]);

  return (
    <div className="page-wrap">
      <Nav />
      <div className="list-page">
        <h1>Winks</h1>
        {winks.length === 0 ? <p className="empty-big">No winks yet</p> : (
          <div className="list">
            {winks.map(w => (
              <div key={w.id} className="list-item" onClick={() => navigate(`/user/${w.from_user_id}`)}>
                <span className="wink-icon">😉</span>
                <div className="li-info"><h3>{w.from_user_name}</h3></div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

// ADMIN DASHBOARD - Owner Only
const AdminDashboard = () => {
  const { token, user } = useAuth();
  const [stats, setStats] = useState(null);
  const [users, setUsers] = useState([]);
  const [subscribers, setSubscribers] = useState([]);
  const [upgradeRequests, setUpgradeRequests] = useState([]);
  const [coinRequests, setCoinRequests] = useState([]);
  const [tab, setTab] = useState('overview');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const isAdmin = user?.email === 'admin@fwbsa.co.za' || user?.role === 'owner' || user?.role === 'admin';

  useEffect(() => {
    if (!isAdmin) { navigate('/home'); return; }
    fetchData();
  }, [isAdmin, navigate]);

  const fetchData = useCallback(async () => {
    try {
      const [statsRes, usersRes, subsRes, upgradeRes, coinRes] = await Promise.all([
        axios.get(`${API}/admin/stats`, { headers: { Authorization: `Bearer ${token}` } }),
        axios.get(`${API}/admin/users`, { headers: { Authorization: `Bearer ${token}` } }),
        axios.get(`${API}/admin/subscribers`, { headers: { Authorization: `Bearer ${token}` } }),
        axios.get(`${API}/admin/upgrade-requests`, { headers: { Authorization: `Bearer ${token}` } }).catch(() => ({ data: { requests: [] } })),
        axios.get(`${API}/admin/coin-requests`, { headers: { Authorization: `Bearer ${token}` } }).catch(() => ({ data: { requests: [] } }))
      ]);
      setStats(statsRes.data);
      setUsers(usersRes.data.users || []);
      setSubscribers(subsRes.data.subscribers || []);
      setUpgradeRequests(upgradeRes.data.requests || []);
      setCoinRequests(coinRes.data.requests || []);
    } catch (e) { console.error(e); }
    setLoading(false);
  }, [token]);

  const approveUpgrade = async (reqId, userId, tier) => {
    try {
      await axios.post(`${API}/admin/approve-upgrade/${reqId}`, {}, { headers: { Authorization: `Bearer ${token}` } });
      setUpgradeRequests(r => r.filter(x => x.id !== reqId));
      setUsers(u => u.map(x => x.id === userId ? { ...x, membership_tier: tier } : x));
      alert('Upgrade approved!');
    } catch (e) { alert('Failed'); }
  };

  const approveCoinPurchase = async (reqId, userId, coins) => {
    try {
      await axios.post(`${API}/admin/approve-coins/${reqId}`, {}, { headers: { Authorization: `Bearer ${token}` } });
      setCoinRequests(r => r.filter(x => x.id !== reqId));
      alert(`${coins} coins added to user!`);
    } catch (e) { alert('Failed'); }
  };

  const rejectRequest = async (type, reqId) => {
    try {
      await axios.post(`${API}/admin/reject-${type}/${reqId}`, {}, { headers: { Authorization: `Bearer ${token}` } });
      if (type === 'upgrade') setUpgradeRequests(r => r.filter(x => x.id !== reqId));
      else setCoinRequests(r => r.filter(x => x.id !== reqId));
    } catch (e) { alert('Failed'); }
  };

  const deleteUser = async (userId, name) => {
    if (window.confirm(`Delete user "${name}" and ALL their data? This cannot be undone.`)) {
      try {
        await axios.delete(`${API}/admin/users/${userId}`, { headers: { Authorization: `Bearer ${token}` } });
        setUsers(u => u.filter(x => x.id !== userId));
        alert('User deleted successfully');
      } catch (e) { alert('Failed to delete'); }
    }
  };

  const viewUserAlbums = async (userId, name) => {
    try {
      const res = await axios.get(`${API}/admin/albums/${userId}`, { headers: { Authorization: `Bearer ${token}` } });
      const albums = res.data.albums || [];
      if (albums.length === 0) { alert(`${name} has no albums`); return; }
      alert(`${name}'s Albums:\n${albums.map(a => `- ${a.name} (${a.is_private ? 'Private' : 'Public'}) - ${a.photos?.length || 0} photos`).join('\n')}`);
    } catch (e) { alert('Failed to load albums'); }
  };

  const upgradeTier = async (userId, tier) => {
    try {
      await axios.post(`${API}/admin/users/${userId}/upgrade?tier=${tier}`, {}, { headers: { Authorization: `Bearer ${token}` } });
      setUsers(u => u.map(x => x.id === userId ? { ...x, membership_tier: tier } : x));
    } catch (e) { alert('Failed to upgrade'); }
  };

  const exportCSV = (data, filename) => {
    const headers = Object.keys(data[0] || {}).join(',');
    const rows = data.map(item => Object.values(item).map(v => `"${v}"`).join(',')).join('\n');
    const csv = `${headers}\n${rows}`;
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
  };

  if (!isAdmin) return null;
  if (loading) return <div className="page-wrap"><Nav /><div className="loading-screen"><div className="spinner"></div></div></div>;

  return (
    <div className="page-wrap">
      <Nav />
      <div className="admin-page">
        <div className="admin-header">
          <h1>Admin Dashboard</h1>
          <span className="owner-badge">Ghost Mode Active</span>
        </div>

        {/* Stats Cards */}
        {stats && (
          <div className="admin-stats">
            <div className="stat-card">
              <span className="stat-num">{stats.total_users}</span>
              <span className="stat-label">Total Users</span>
            </div>
            <div className="stat-card">
              <span className="stat-num">{stats.total_subscribers}</span>
              <span className="stat-label">Email Subscribers</span>
            </div>
            <div className="stat-card">
              <span className="stat-num">{stats.recent_signups}</span>
              <span className="stat-label">This Week</span>
            </div>
            <div className="stat-card gold">
              <span className="stat-num">{stats.tier_breakdown?.gold || 0}</span>
              <span className="stat-label">Gold Members</span>
            </div>
            <div className="stat-card plat">
              <span className="stat-num">{stats.tier_breakdown?.platinum || 0}</span>
              <span className="stat-label">Platinum Members</span>
            </div>
          </div>
        )}

        {/* Tabs */}
        <div className="admin-tabs">
          <button className={tab === 'overview' ? 'active' : ''} onClick={() => setTab('overview')}>Overview</button>
          <button className={tab === 'upgrades' ? 'active' : ''} onClick={() => setTab('upgrades')}>Upgrade Requests ({upgradeRequests.length})</button>
          <button className={tab === 'coins' ? 'active' : ''} onClick={() => setTab('coins')}>Coin Purchases ({coinRequests.length})</button>
          <button className={tab === 'members' ? 'active' : ''} onClick={() => setTab('members')}>Paid Members</button>
          <button className={tab === 'users' ? 'active' : ''} onClick={() => setTab('users')}>Users ({users.length})</button>
          <button className={tab === 'subscribers' ? 'active' : ''} onClick={() => setTab('subscribers')}>Subscribers ({subscribers.length})</button>
        </div>

        {/* Paid Members Tab - Gold & Platinum Tracking */}
        {tab === 'members' && (
          <div className="admin-section">
            <h2>Paid Members Tracking</h2>
            <p className="section-desc">Monitor Gold & Platinum memberships. Auto-cancel after 1 month if no renewal.</p>
            
            <div className="members-section">
              <h3 style={{color: '#E8E8E8', borderBottom: '2px solid #E8E8E8', paddingBottom: 8, marginBottom: 16}}>Platinum Members ({users.filter(u => u.membership_tier === 'platinum').length})</h3>
              {users.filter(u => u.membership_tier === 'platinum').length === 0 ? <p className="empty">No platinum members</p> : (
                <div className="members-list">
                  {users.filter(u => u.membership_tier === 'platinum').map(u => (
                    <div key={u.id} className="member-card platinum">
                      <div className="member-info">
                        <strong>{u.name}</strong>
                        <p>Member #: {u.membership_number || 'N/A'}</p>
                        <p>Signed up: {new Date(u.created_at).toLocaleDateString()}</p>
                        <p>Expires: {u.membership_expires ? new Date(u.membership_expires).toLocaleDateString() : 'Not set'}</p>
                      </div>
                      <div className="member-actions">
                        <button className="downgrade-btn" onClick={() => upgradeTier(u.id, 'silver')}>Downgrade to Silver</button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="members-section" style={{marginTop: 32}}>
              <h3 style={{color: '#FFD700', borderBottom: '2px solid #FFD700', paddingBottom: 8, marginBottom: 16}}>Gold Members ({users.filter(u => u.membership_tier === 'gold').length})</h3>
              {users.filter(u => u.membership_tier === 'gold').length === 0 ? <p className="empty">No gold members</p> : (
                <div className="members-list">
                  {users.filter(u => u.membership_tier === 'gold').map(u => (
                    <div key={u.id} className="member-card gold">
                      <div className="member-info">
                        <strong>{u.name}</strong>
                        <p>Member #: {u.membership_number || 'N/A'}</p>
                        <p>Reason: {u.gold_reason === 'female_default' ? 'Women\'s Perk' : u.gold_reason === 'early_access' ? 'Early Access' : 'Paid'}</p>
                        <p>Signed up: {new Date(u.created_at).toLocaleDateString()}</p>
                        <p>Expires: {u.gold_expires_at ? new Date(u.gold_expires_at).toLocaleDateString() : 'Not set'}</p>
                      </div>
                      <div className="member-actions">
                        <button className="upgrade-btn" onClick={() => upgradeTier(u.id, 'platinum')}>Upgrade to Platinum</button>
                        <button className="downgrade-btn" onClick={() => upgradeTier(u.id, 'silver')}>Downgrade to Silver</button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}

        {/* Upgrade Requests Tab */}
        {tab === 'upgrades' && (
          <div className="admin-section">
            <h2>Membership Upgrade Requests</h2>
            {upgradeRequests.length === 0 ? <p className="empty">No pending upgrade requests</p> : (
              <div className="request-list">
                {upgradeRequests.map(r => (
                  <div key={r.id} className="request-card">
                    <div className="request-info">
                      <h3>{r.user_name}</h3>
                      <p>Requesting: <strong className={r.tier}>{r.tier}</strong></p>
                      <p>Membership #: {r.membership_number}</p>
                      <p>Amount: R{r.amount}</p>
                      <p>Date: {new Date(r.created_at).toLocaleDateString()}</p>
                    </div>
                    <div className="request-actions">
                      <button className="approve-btn" onClick={() => approveUpgrade(r.id, r.user_id, r.tier)}>Approve</button>
                      <button className="reject-btn" onClick={() => rejectRequest('upgrade', r.id)}>Reject</button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* Coin Purchase Requests Tab */}
        {tab === 'coins' && (
          <div className="admin-section">
            <h2>Coin Purchase Requests</h2>
            {coinRequests.length === 0 ? <p className="empty">No pending coin purchases</p> : (
              <div className="request-list">
                {coinRequests.map(r => (
                  <div key={r.id} className="request-card">
                    <div className="request-info">
                      <h3>{r.user_name}</h3>
                      <p>Coins: <strong>{r.coins}</strong></p>
                      <p>Membership #: {r.membership_number}</p>
                      <p>Amount: R{r.amount}</p>
                      <p>Date: {new Date(r.created_at).toLocaleDateString()}</p>
                    </div>
                    <div className="request-actions">
                      <button className="approve-btn" onClick={() => approveCoinPurchase(r.id, r.user_id, r.coins)}>Approve</button>
                      <button className="reject-btn" onClick={() => rejectRequest('coins', r.id)}>Reject</button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* Overview Tab */}
        {tab === 'overview' && stats && (
          <div className="admin-overview">
            <div className="overview-section">
              <h3>Tier Breakdown</h3>
              <div className="tier-bars">
                <div className="tier-bar">
                  <span>Silver (Free)</span>
                  <div className="bar"><div style={{ width: `${(stats.tier_breakdown.silver / stats.total_users) * 100}%`, background: '#A8A8A8' }}></div></div>
                  <span>{stats.tier_breakdown.silver}</span>
                </div>
                <div className="tier-bar">
                  <span>Gold</span>
                  <div className="bar"><div style={{ width: `${(stats.tier_breakdown.gold / stats.total_users) * 100}%`, background: '#FFD700' }}></div></div>
                  <span>{stats.tier_breakdown.gold}</span>
                </div>
                <div className="tier-bar">
                  <span>Platinum</span>
                  <div className="bar"><div style={{ width: `${(stats.tier_breakdown.platinum / stats.total_users) * 100}%`, background: '#E8E8E8' }}></div></div>
                  <span>{stats.tier_breakdown.platinum}</span>
                </div>
              </div>
            </div>
            <div className="overview-section">
              <h3>Content Stats</h3>
              <div className="content-stats">
                <div><span>📸</span> {stats.total_photos} Photos</div>
                <div><span>💬</span> {stats.total_socials} Socials</div>
                <div><span>🎉</span> {stats.total_events} Events</div>
              </div>
            </div>
          </div>
        )}

        {/* Users Tab */}
        {tab === 'users' && (
          <div className="admin-users">
            <div className="admin-actions">
              <button onClick={() => exportCSV(users.map(u => ({ name: u.name, email: u.email, tier: u.membership_tier, joined: u.created_at })), 'users.csv')}>
                📥 Export CSV
              </button>
            </div>
            <div className="users-table">
              <div className="table-header">
                <span>User</span>
                <span>Email</span>
                <span>Tier</span>
                <span>Joined</span>
                <span>Actions</span>
              </div>
              {users.map(u => (
                <div key={u.id} className="table-row">
                  <span className="user-cell">
                    <div className="mini-avatar">{u.profile_photo ? <img src={u.profile_photo} alt="" /> : u.name?.charAt(0)}</div>
                    {u.name}
                    {u.role === 'owner' && <span className="owner-tag">👑</span>}
                  </span>
                  <span>{u.email}</span>
                  <span>
                    <select value={u.membership_tier} onChange={e => upgradeTier(u.id, e.target.value)} disabled={u.email === 'admin@fwbsa.co.za'}>
                      <option value="silver">Silver</option>
                      <option value="gold">Gold</option>
                      <option value="platinum">Platinum</option>
                    </select>
                  </span>
                  <span>{new Date(u.created_at).toLocaleDateString()}</span>
                  <span className="admin-user-actions">
                    <button className="view-btn" onClick={() => navigate(`/user/${u.id}`)} title="View Profile">👁️</button>
                    <button className="album-btn" onClick={() => viewUserAlbums(u.id, u.name)} title="View Albums">📁</button>
                    {u.email !== 'admin@fwbsa.co.za' && (
                      <button className="del-btn" onClick={() => deleteUser(u.id, u.name)} title="Delete User">🗑️</button>
                    )}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Subscribers Tab */}
        {tab === 'subscribers' && (
          <div className="admin-subscribers">
            <div className="admin-actions">
              <button onClick={() => exportCSV(subscribers, 'subscribers.csv')}>
                📥 Export CSV
              </button>
            </div>
            <div className="subs-list">
              {subscribers.length === 0 ? <p className="empty">No subscribers yet</p> : subscribers.map(s => (
                <div key={s.id} className="sub-item">
                  <span className="sub-email">{s.email}</span>
                  <span className="sub-date">{new Date(s.subscribed_at).toLocaleString()}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const EventsPage = () => {
  const { token, user } = useAuth();
  const [events, setEvents] = useState([]);
  const [showCreate, setShowCreate] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [newEvent, setNewEvent] = useState({ title: '', description: '', location: '', event_date: '', event_type: 'party' });
  const navigate = useNavigate();
  const tier = user?.membership_tier || 'silver';
  const isAdmin = user?.email === 'admin@fwbsa.co.za' || user?.role === 'admin' || user?.role === 'owner';
  const isSilver = tier === 'silver' && !isAdmin;
  const canCreate = tier === 'gold' || tier === 'platinum' || isAdmin;
  const canView = tier === 'gold' || tier === 'platinum' || isAdmin;
  const eventTypes = ['party', 'meetup', 'club_night', 'house_party', 'hotel_takeover', 'other'];

  const loadEvents = () => {
    axios.get(`${API}/events`, { headers: { Authorization: `Bearer ${token}` } }).then(r => setEvents(r.data || []));
  };

  useEffect(() => { loadEvents(); }, [token]);

  const createEvent = async () => {
    if (!newEvent.title.trim() || !newEvent.location.trim() || !newEvent.event_date) { alert('Please fill all fields'); return; }
    try {
      await axios.post(`${API}/events`, newEvent, { headers: { Authorization: `Bearer ${token}` } });
      setNewEvent({ title: '', description: '', location: '', event_date: '', event_type: 'party' });
      setShowCreate(false);
      loadEvents();
    } catch (e) { alert(e.response?.data?.detail || 'Failed to create event'); }
  };

  const deleteEvent = async (eventId) => {
    if (!window.confirm('Delete this event?')) return;
    try {
      await axios.delete(`${API}/admin/events/${eventId}`, { headers: { Authorization: `Bearer ${token}` } });
      loadEvents();
      setSelectedEvent(null);
    } catch (e) { alert('Failed to delete'); }
  };

  return (
    <div className="page-wrap">
      <Nav />
      <div className="events-page">
        <div className="page-head">
          <h1>Events & Parties</h1>
          {canCreate && <button className="btn-create" onClick={() => setShowCreate(true)}>+ Create Event</button>}
        </div>
        <div className="early-access-notice">Early Access Launch - Be part of the first events!</div>
        
        {isSilver && (
          <div className="tier-block">
            <p>Upgrade to <strong>Gold</strong> to view event details and join parties!</p>
            <button onClick={() => navigate('/membership')}>Upgrade Now</button>
          </div>
        )}
        
        {events.length === 0 ? <p className="empty-big">No upcoming events. Create one!</p> : (
          <div className="events-grid">
            {events.map(e => (
              <div key={e.id} className={`event-card ${isSilver ? 'locked' : ''}`} onClick={() => { if(canView || isAdmin) setSelectedEvent(e); else navigate('/membership'); }}>
                <h3>{(canView || isAdmin) ? e.title : '***********'}</h3>
                <p>{(canView || isAdmin) ? (e.description?.slice(0, 80) + (e.description?.length > 80 ? '...' : '')) : '******************'}</p>
                <p className="ef-meta">{(canView || isAdmin) ? `${e.location} • ${new Date(e.event_date).toLocaleDateString()}` : '*** • ***'}</p>
                <span className="event-type">{e.event_type?.replace(/_/g, ' ')}</span>
                {isSilver && !isAdmin && <div className="lock-overlay">Upgrade to View</div>}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Event Detail Modal */}
      {selectedEvent && (canView || isAdmin) && (
        <div className="modal-overlay" onClick={() => setSelectedEvent(null)}>
          <div className="post-detail-modal" onClick={e => e.stopPropagation()}>
            <div className="post-body">
              <h2>{selectedEvent.title}</h2>
              <span className="event-type" style={{marginBottom: 16, display: 'inline-block'}}>{selectedEvent.event_type?.replace(/_/g, ' ')}</span>
              <p className="description">{selectedEvent.description}</p>
              <div className="post-details">
                <div className="detail-row"><span className="detail-label">Location</span><span className="detail-value">{selectedEvent.location}</span></div>
                <div className="detail-row"><span className="detail-label">Date</span><span className="detail-value">{new Date(selectedEvent.event_date).toLocaleDateString()}</span></div>
                <div className="detail-row"><span className="detail-label">Host</span><span className="detail-value">{selectedEvent.creator_name || 'Anonymous'}</span></div>
                <div className="detail-row"><span className="detail-label">Attendees</span><span className="detail-value">{selectedEvent.attendees?.length || 0}</span></div>
              </div>
            </div>
            <div className="modal-actions" style={{marginTop: 20}}>
              <button className="btn-cancel" onClick={() => setSelectedEvent(null)}>Close</button>
              {canCreate && selectedEvent.creator_id !== user?.id && <button className="btn-submit" onClick={() => { setSelectedEvent(null); navigate(`/messages/${selectedEvent.creator_id}`); }}>Message Host</button>}
              {(selectedEvent.creator_id === user?.id || isAdmin) && <button className="btn-delete" onClick={() => deleteEvent(selectedEvent.id)}>Delete</button>}
            </div>
          </div>
        </div>
      )}

      {showCreate && (
        <div className="modal-overlay" onClick={() => setShowCreate(false)}>
          <div className="modal-content create-modal" onClick={e => e.stopPropagation()}>
            <h3>Create Event / Party</h3>
            <input type="text" placeholder="Event Title" value={newEvent.title} onChange={e => setNewEvent({...newEvent, title: e.target.value})} />
            <textarea placeholder="Description..." value={newEvent.description} onChange={e => setNewEvent({...newEvent, description: e.target.value})} rows={4} />
            <div className="form-group">
              <label>Event Type</label>
              <select value={newEvent.event_type} onChange={e => setNewEvent({...newEvent, event_type: e.target.value})}>
                {eventTypes.map(t => <option key={t} value={t}>{t.replace(/_/g, ' ')}</option>)}
              </select>
            </div>
            <input type="text" placeholder="Location (e.g., Sandton, JHB)" value={newEvent.location} onChange={e => setNewEvent({...newEvent, location: e.target.value})} />
            <input type="date" value={newEvent.event_date} onChange={e => setNewEvent({...newEvent, event_date: e.target.value})} />
            <div className="modal-actions">
              <button className="btn-cancel" onClick={() => setShowCreate(false)}>Cancel</button>
              <button className="btn-submit" onClick={createEvent}>Create Event</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// DESIRES/KINKS OPTIONS
const DESIRES_OPTIONS = [
  'Voyeurism', 'Exhibitionism', 'Threesomes', 'Group Play', 'Soft Swap', 'Full Swap',
  'Same Room', 'BDSM Light', 'BDSM Heavy', 'Role Play', 'Sensual Massage', 'Tantra',
  'Single Male', 'Single Female', 'Couples Only', 'First Timers Welcome', 'Experienced Only',
  'Hotel Takeovers', 'House Parties', 'Club Events', 'Outdoor', 'Travel Partners',
  'Long Term', 'One Time', 'Friendship First', 'NSA', 'Discretion Required'
];

// FORUM PAGE
const ForumPage = () => {
  const { token, user } = useAuth();
  const [posts, setPosts] = useState([]);
  const [category, setCategory] = useState('all');
  const [showCreate, setShowCreate] = useState(false);
  const [newPost, setNewPost] = useState({ title: '', content: '', category: 'general' });
  const [loading, setLoading] = useState(true);

  const categories = ['all', 'general', 'advice', 'stories', 'events', 'lifestyle'];

  const loadPosts = useCallback(async () => {
    setLoading(true);
    try {
      const params = category !== 'all' ? `?category=${category}` : '';
      const res = await axios.get(`${API}/forum/posts${params}`, { headers: { Authorization: `Bearer ${token}` } });
      setPosts(res.data.posts || []);
    } catch (e) { console.log(e); }
    setLoading(false);
  }, [token, category]);

  useEffect(() => {
    loadPosts();
  }, [loadPosts]);

  const createPost = async () => {
    if (!newPost.title.trim() || !newPost.content.trim()) return;
    try {
      await axios.post(`${API}/forum/posts`, newPost, { headers: { Authorization: `Bearer ${token}` } });
      setNewPost({ title: '', content: '', category: 'general' });
      setShowCreate(false);
      loadPosts();
    } catch (e) { alert('Failed to create post'); }
  };

  const likePost = async (postId) => {
    try {
      await axios.post(`${API}/forum/posts/${postId}/like`, {}, { headers: { Authorization: `Bearer ${token}` } });
      loadPosts();
    } catch (e) { console.log(e); }
  };

  const formatDate = (iso) => {
    const d = new Date(iso);
    const now = new Date();
    const diff = (now - d) / 1000;
    if (diff < 60) return 'Just now';
    if (diff < 3600) return `${Math.floor(diff/60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff/3600)}h ago`;
    return d.toLocaleDateString();
  };

  return (
    <div className="page-wrap">
      <Nav />
      <div className="forum-page mobile-friendly">
        <h1>💬 Community Forum</h1>
        
        <div className="forum-tabs">
          {categories.map(cat => (
            <button key={cat} className={category === cat ? 'active' : ''} onClick={() => setCategory(cat)}>
              {cat.charAt(0).toUpperCase() + cat.slice(1)}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="loading-spinner">Loading...</div>
        ) : posts.length === 0 ? (
          <div className="empty-state">
            <p>No posts yet. Be the first to start a discussion!</p>
          </div>
        ) : (
          posts.map(post => (
            <div key={post.id} className="forum-post">
              <div className="forum-post-header">
                <div className="forum-author-pic">
                  {post.author_photo ? <img src={post.author_photo} alt="" /> : <span>👤</span>}
                </div>
                <div className="forum-author-info">
                  <h4>{post.author_name}</h4>
                  <span>{formatDate(post.created_at)} • {post.category}</span>
                </div>
              </div>
              <h3>{post.title}</h3>
              <p>{post.content}</p>
              <div className="forum-actions">
                <button onClick={() => likePost(post.id)}>❤️ {post.likes || 0}</button>
                <button>💬 {post.comments?.length || 0}</button>
              </div>
            </div>
          ))
        )}

        <button className="create-post-btn" onClick={() => setShowCreate(true)}>+</button>

        {showCreate && (
          <div className="modal" onClick={() => setShowCreate(false)}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
              <h3>Create Post</h3>
              <div className="form-group">
                <select value={newPost.category} onChange={e => setNewPost({...newPost, category: e.target.value})}>
                  <option value="general">General</option>
                  <option value="advice">Advice</option>
                  <option value="stories">Stories</option>
                  <option value="events">Events</option>
                  <option value="lifestyle">Lifestyle</option>
                </select>
              </div>
              <div className="form-group">
                <input type="text" placeholder="Title..." value={newPost.title} onChange={e => setNewPost({...newPost, title: e.target.value})} />
              </div>
              <div className="form-group">
                <textarea placeholder="What's on your mind..." rows={4} value={newPost.content} onChange={e => setNewPost({...newPost, content: e.target.value})} />
              </div>
              <div className="modal-actions">
                <button onClick={() => setShowCreate(false)}>Cancel</button>
                <button className="primary" onClick={createPost}>Post</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

// SETTINGS PAGE
const SettingsPage = () => {
  const { user, token, logout, refreshUser } = useAuth();
  const navigate = useNavigate();
  const [blocked, setBlocked] = useState([]);
  const [showLegal, setShowLegal] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [passwords, setPasswords] = useState({ current: '', new: '', confirm: '' });
  const [pwLoading, setPwLoading] = useState(false);
  const [privacy, setPrivacy] = useState({ incognito_mode: false, blur_profile_photo: false, hidden_locations: [] });
  const [travelMode, setTravelMode] = useState(null);
  const [coupleRequests, setCoupleRequests] = useState([]);
  const [linkedPartner, setLinkedPartner] = useState(null);
  const [newLocation, setNewLocation] = useState('');

  const loadSettings = useCallback(async () => {
    try {
      const [blockedRes, privacyRes, requestsRes] = await Promise.all([
        axios.get(`${API}/users/blocked`, { headers: { Authorization: `Bearer ${token}` } }),
        axios.get(`${API}/settings/privacy`, { headers: { Authorization: `Bearer ${token}` } }),
        axios.get(`${API}/couples/requests`, { headers: { Authorization: `Bearer ${token}` } })
      ]);
      setBlocked(blockedRes.data || []);
      setPrivacy(privacyRes.data);
      setCoupleRequests(requestsRes.data.requests || []);
      setTravelMode(user?.travel_mode);
      if (user?.linked_partner_id) {
        const partnerRes = await axios.get(`${API}/users/${user.linked_partner_id}`, { headers: { Authorization: `Bearer ${token}` } });
        setLinkedPartner(partnerRes.data);
      }
    } catch (e) { console.log(e); }
  }, [token, user]);


  useEffect(() => {
    loadSettings();
  }, [loadSettings]);


  const updatePrivacy = async (key, value) => {
    const newPrivacy = { ...privacy, [key]: value };
    setPrivacy(newPrivacy);
    try {
      await axios.put(`${API}/settings/privacy`, newPrivacy, { headers: { Authorization: `Bearer ${token}` } });
    } catch (e) { alert('Failed to update'); }
  };

  const addHiddenLocation = () => {
    if (newLocation.trim() && !privacy.hidden_locations.includes(newLocation.trim())) {
      updatePrivacy('hidden_locations', [...privacy.hidden_locations, newLocation.trim()]);
      setNewLocation('');
    }
  };

  const removeHiddenLocation = (loc) => {
    updatePrivacy('hidden_locations', privacy.hidden_locations.filter(l => l !== loc));
  };

  const updateTravelMode = async (city) => {
    try {
      const data = city ? { city, until_date: new Date(Date.now() + 7*24*60*60*1000).toISOString() } : { city: null };
      await axios.put(`${API}/settings/travel-mode`, data, { headers: { Authorization: `Bearer ${token}` } });
      setTravelMode(city ? data : null);
      refreshUser();
    } catch (e) { alert('Failed'); }
  };

  const acceptCouple = async (requesterId) => {
    try {
      await axios.post(`${API}/couples/accept/${requesterId}`, {}, { headers: { Authorization: `Bearer ${token}` } });
      refreshUser();
      loadSettings();
    } catch (e) { alert('Failed'); }
  };

  const declineCouple = async (requesterId) => {
    try {
      await axios.post(`${API}/couples/decline/${requesterId}`, {}, { headers: { Authorization: `Bearer ${token}` } });
      loadSettings();
    } catch (e) { alert('Failed'); }
  };

  const unlinkPartner = async () => {
    if (!window.confirm('Unlink from your partner?')) return;
    try {
      await axios.delete(`${API}/couples/unlink`, { headers: { Authorization: `Bearer ${token}` } });
      setLinkedPartner(null);
      refreshUser();
    } catch (e) { alert('Failed'); }
  };

  const unblock = async (userId) => {
    try {
      await axios.post(`${API}/users/${userId}/unblock`, {}, { headers: { Authorization: `Bearer ${token}` } });
      setBlocked(b => b.filter(u => u.id !== userId));
    } catch (e) { alert('Failed to unblock'); }
  };

  const changePassword = async () => {
    if (passwords.new !== passwords.confirm) { alert('New passwords do not match'); return; }
    if (passwords.new.length < 6) { alert('Password must be at least 6 characters'); return; }
    setPwLoading(true);
    try {
      await axios.post(`${API}/auth/change-password`, { current_password: passwords.current, new_password: passwords.new }, { headers: { Authorization: `Bearer ${token}` } });
      alert('Password changed successfully!');
      setShowPassword(false);
      setPasswords({ current: '', new: '', confirm: '' });
    } catch (e) { alert(e.response?.data?.detail || 'Failed to change password'); }
    setPwLoading(false);
  };

  const deleteAccount = async () => {
    if (window.confirm('Are you sure you want to delete your account? This cannot be undone.')) {
      if (window.confirm('This will permanently delete all your data, photos, matches and messages. Continue?')) {
        try {
          await axios.delete(`${API}/users/me`, { headers: { Authorization: `Bearer ${token}` } });
          alert('Account deleted. Goodbye!');
          logout();
        } catch (e) { alert('Failed to delete account'); }
      }
    }
  };

  return (
    <div className="page-wrap">
      <Nav />
      <div className="settings-page mobile-friendly">
        <h1>⚙️ Settings</h1>

        {/* Account Settings */}
        <div className="settings-section">
          <h2>👤 Account</h2>
          <div className="settings-list">
            <div className="setting-item" onClick={() => navigate('/profile/edit')}><span>Edit Profile</span><span>→</span></div>
            <div className="setting-item" onClick={() => navigate('/membership')}>
              <span>Membership</span>
              <span className={`tier-tag ${user?.membership_tier}`}>{user?.membership_tier?.toUpperCase()}</span>
            </div>
            <div className="setting-item"><span>Email</span><span className="muted">{user?.email}</span></div>
            <div className="setting-item" onClick={() => setShowPassword(true)}><span>Change Password</span><span>→</span></div>
          </div>
        </div>

        {/* Couples Linking */}
        <div className="settings-section">
          <h2>💑 Couples Linking</h2>
          {linkedPartner ? (
            <div className="linked-partner">
              <div className="partner-info">
                <div className="partner-avatar">
                  {linkedPartner.profile_photo ? <img src={linkedPartner.profile_photo} alt="" /> : <span>👤</span>}
                </div>
                <div>
                  <p>Linked with <strong>{linkedPartner.name}</strong></p>
                  <small>Your profiles appear together</small>
                </div>
              </div>
              <button className="unlink-btn" onClick={unlinkPartner}>Unlink</button>
            </div>
          ) : (
            <div className="couple-section">
              <p className="hint">Link your profile with your partner to appear as a couple</p>
              {coupleRequests.length > 0 && (
                <div className="couple-requests">
                  <h4>Pending Requests</h4>
                  {coupleRequests.map(req => (
                    <div key={req.id} className="couple-request">
                      <span>{req.requester?.name || 'Someone'} wants to link</span>
                      <div>
                        <button className="accept" onClick={() => acceptCouple(req.requester_id)}>Accept</button>
                        <button className="decline" onClick={() => declineCouple(req.requester_id)}>Decline</button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              <p className="hint">To link, visit your partner's profile and tap "Link as Couple"</p>
            </div>
          )}
        </div>

        {/* Privacy Settings */}
        <div className="settings-section">
          <h2>🔒 Privacy</h2>
          <div className="settings-list">
            <div className="setting-item toggle">
              <div>
                <span>Incognito Mode</span>
                <small>{(user?.membership_tier === 'platinum' || user?.email === 'admin@fwbsa.co.za') ? 'Browse without being seen' : 'Platinum members only'}</small>
              </div>
              <label className="switch">
                <input type="checkbox" 
                  checked={privacy.incognito_mode} 
                  disabled={user?.membership_tier !== 'platinum' && user?.email !== 'admin@fwbsa.co.za'}
                  onChange={async (e) => {
                    try {
                      const res = await axios.post(`${API}/profile/incognito/toggle`, {}, { headers: { Authorization: `Bearer ${token}` } });
                      setPrivacy(prev => ({...prev, incognito_mode: res.data.incognito_mode}));
                    } catch(err) { alert(err.response?.data?.detail || 'Platinum only'); }
                  }} 
                />
                <span className="slider"></span>
              </label>
            </div>
          </div>
        </div>

        {/* Blocked Users */}
        <div className="settings-section">
          <h2>🚫 Blocked Users ({blocked.length})</h2>
          {blocked.length === 0 ? <p className="empty-sm">No blocked users</p> : (
            <div className="blocked-list">
              {blocked.map(u => (
                <div key={u.id} className="blocked-item">
                  <span>{u.name}</span>
                  <button onClick={() => unblock(u.id)}>Unblock</button>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Legal */}
        <div className="settings-section">
          <h2>📋 Legal</h2>
          <div className="settings-list">
            <div className="setting-item" onClick={() => setShowLegal('terms')}><span>Terms & Conditions</span><span>→</span></div>
            <div className="setting-item" onClick={() => setShowLegal('privacy')}><span>Privacy Policy</span><span>→</span></div>
            <div className="setting-item" onClick={() => setShowLegal('popi')}><span>POPIA Compliance</span><span>→</span></div>
            <div className="setting-item" onClick={() => setShowLegal('community')}><span>Community Guidelines</span><span>→</span></div>
          </div>
        </div>

        {/* Danger Zone */}
        <div className="settings-section danger">
          <h2>⚠️ Danger Zone</h2>
          <div className="settings-list">
            <div className="setting-item" onClick={logout}><span>Log Out</span><span>→</span></div>
            <div className="setting-item red" onClick={deleteAccount}><span>Delete Account</span><span>⚠️</span></div>
          </div>
        </div>

        {/* Modals */}
        {showLegal && (
          <div className="legal-modal" onClick={() => setShowLegal(null)}>
            <div className="legal-content" onClick={e => e.stopPropagation()}>
              <button className="close-btn" onClick={() => setShowLegal(null)}>✕</button>
              {showLegal === 'terms' && <LegalTerms />}
              {showLegal === 'privacy' && <LegalPrivacy />}
              {showLegal === 'popi' && <LegalPOPI />}
              {showLegal === 'community' && <LegalCommunity />}
            </div>
          </div>
        )}

        {showPassword && (
          <div className="legal-modal" onClick={() => setShowPassword(false)}>
            <div className="legal-content password-modal" onClick={e => e.stopPropagation()}>
              <button className="close-btn" onClick={() => setShowPassword(false)}>✕</button>
              <div className="password-form">
                <h2>Change Password</h2>
                <div className="form-group">
                  <label>Current Password</label>
                  <input type="password" placeholder="Enter current password" value={passwords.current} onChange={e => setPasswords({...passwords, current: e.target.value})} />
                </div>
                <div className="form-group">
                  <label>New Password</label>
                  <input type="password" placeholder="Enter new password (min 6 chars)" value={passwords.new} onChange={e => setPasswords({...passwords, new: e.target.value})} />
                </div>
                <div className="form-group">
                  <label>Confirm New Password</label>
                  <input type="password" placeholder="Confirm new password" value={passwords.confirm} onChange={e => setPasswords({...passwords, confirm: e.target.value})} />
                </div>
                <button className="btn-save" onClick={changePassword} disabled={pwLoading}>{pwLoading ? 'Changing...' : 'Change Password'}</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

// Legal Document Components
const LegalTerms = () => (
  <div className="legal-doc">
    <h2>Terms & Conditions</h2>
    <p className="updated">Last updated: {new Date().toLocaleDateString()}</p>
    <h3>1. Acceptance of Terms</h3>
    <p>By accessing and using FWB SA, you agree to be bound by these Terms & Conditions. If you do not agree, please do not use our services.</p>
    <h3>2. Eligibility</h3>
    <p>You must be at least 18 years old to use FWB SA. By using our service, you represent and warrant that you meet this age requirement.</p>
    <h3>3. Account Registration</h3>
    <p>You agree to provide accurate, current, and complete information during registration. You are responsible for maintaining the confidentiality of your account credentials.</p>
    <h3>4. User Conduct</h3>
    <p>You agree not to: harass, abuse, or harm other users; post illegal or explicit content involving minors; impersonate others; use automated systems or bots; violate any applicable laws.</p>
    <h3>5. Content</h3>
    <p>You retain ownership of content you post, but grant FWB SA a license to use, display, and distribute such content on our platform.</p>
    <h3>6. Termination</h3>
    <p>We reserve the right to suspend or terminate your account at any time for violations of these terms or for any other reason at our discretion.</p>
    <h3>7. Disclaimer</h3>
    <p>FWB SA is provided "as is" without warranties of any kind. We are not responsible for the actions of users or the accuracy of user-provided information.</p>
    <h3>8. Limitation of Liability</h3>
    <p>FWB SA shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of our services.</p>
  </div>
);

const LegalPrivacy = () => (
  <div className="legal-doc">
    <h2>Privacy Policy</h2>
    <p className="updated">Last updated: {new Date().toLocaleDateString()}</p>
    <h3>1. Information We Collect</h3>
    <p>We collect information you provide directly: name, email, date of birth, gender, location, photos, preferences, and profile information.</p>
    <h3>2. How We Use Your Information</h3>
    <p>To provide and improve our services, match you with other users, communicate with you, and ensure safety and security on our platform.</p>
    <h3>3. Information Sharing</h3>
    <p>We do not sell your personal information. We may share information with service providers, for legal compliance, or with your consent.</p>
    <h3>4. Data Security</h3>
    <p>We implement appropriate security measures to protect your personal information from unauthorized access, alteration, or destruction.</p>
    <h3>5. Your Rights</h3>
    <p>You have the right to access, correct, delete, or export your personal data. Contact us to exercise these rights.</p>
    <h3>6. Cookies</h3>
    <p>We use cookies and similar technologies to enhance your experience and analyze usage patterns.</p>
    <h3>7. Contact</h3>
    <p>For privacy-related inquiries, contact us at privacy@fwbsa.co.za</p>
  </div>
);

const LegalPOPI = () => (
  <div className="legal-doc">
    <h2>POPIA Compliance</h2>
    <p className="updated">Protection of Personal Information Act (South Africa)</p>
    <h3>Our Commitment</h3>
    <p>FWB SA is committed to complying with the Protection of Personal Information Act (POPIA) of South Africa.</p>
    <h3>Information Officer</h3>
    <p>Our Information Officer is responsible for ensuring POPIA compliance. Contact: info@fwbsa.co.za</p>
    <h3>Your Rights Under POPIA</h3>
    <ul>
      <li>Right to be notified of data collection</li>
      <li>Right to access your personal information</li>
      <li>Right to request correction of your data</li>
      <li>Right to request deletion of your data</li>
      <li>Right to object to processing</li>
      <li>Right to submit a complaint to the Information Regulator</li>
    </ul>
    <h3>Data Processing</h3>
    <p>We process your data lawfully, for specific purposes, and with adequate security measures in place.</p>
    <h3>Data Retention</h3>
    <p>We retain your data only as long as necessary for the purposes for which it was collected, or as required by law.</p>
  </div>
);

const LegalCommunity = () => (
  <div className="legal-doc">
    <h2>Community Guidelines</h2>
    <h3>Respect Others</h3>
    <p>Treat all members with respect. Harassment, hate speech, and discrimination will not be tolerated.</p>
    <h3>Be Honest</h3>
    <p>Use recent photos and accurate information in your profile. Misrepresentation is grounds for account suspension.</p>
    <h3>Consent is Key</h3>
    <p>Always obtain clear consent before any interaction. No means no. Respect boundaries.</p>
    <h3>Keep it Legal</h3>
    <p>All activities must be legal. No solicitation, illegal substances, or underage content.</p>
    <h3>Report Violations</h3>
    <p>If you encounter inappropriate behavior, report it immediately using the block/report feature.</p>
    <h3>Safety First</h3>
    <p>Meet in public places first. Tell a friend where you're going. Trust your instincts.</p>
  </div>
);


// ==================== NOTIFICATIONS PAGE ====================
const NotificationsPage = () => {
  const { token, user, refreshUser } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const loadAll = async () => {
    try {
      const res = await axios.get(`${API}/notifications`, { headers: { Authorization: `Bearer ${token}` } });
      const list = res.data?.notifications || res.data || [];
      setItems(list);
    } catch (e) {
      console.error('Notifications load failed', e);
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  const markRead = async (id) => {
    try {
      await axios.post(`${API}/notifications/${id}/read`, {}, { headers: { Authorization: `Bearer ${token}` } });
      // Refresh badge counts in header
      refreshUser?.();
      setItems(prev => prev.map(n => n.id === id ? { ...n, is_read: true } : n));
    } catch (e) {
      console.error('Mark read failed', e);
    }
  };

  useEffect(() => { loadAll(); }, []);

  return (
    <div className="page-wrap">
      <Nav />
      <div className="page" style={{maxWidth:600,margin:'0 auto',padding:'16px'}}>
        <div className="page-head">
          <button className="btn-back" onClick={() => navigate(-1)}>←</button>
          <h2>Notifications</h2>
        </div>

        {loading ? (
          <p className="muted">Loading…</p>
        ) : items.length === 0 ? (
          <p className="muted">No notifications yet.</p>
        ) : (
          <div className="notifications-list">
            {items.map(n => (
              <div
                key={n.id}
                className={`notification-item ${n.is_read ? '' : 'unread'}`}
                onClick={() => { if (!n.is_read) markRead(n.id); if(n.link) navigate(n.link); }}
              >
                <div className="nt-title">{n.title || 'Notification'}</div>
                <div className="nt-body">{n.message || n.body || ''}</div>
                <div className="nt-time">{n.created_at ? new Date(n.created_at).toLocaleString() : ''}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

// ==================== ARTICLE PAGE ====================
const ArticlePage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const article = ARTICLES?.[slug];

  if (!article) {
    return (
      <div className="page-wrap"><Nav />
        <div className="page" style={{padding:'24px 16px',maxWidth:720,margin:'0 auto'}}>
          <button onClick={() => navigate(-1)} style={{background:'none',border:'none',color:'#14b8a6',cursor:'pointer',fontSize:16,marginBottom:16}}>\u2190 Back</button>
          <h2 style={{color:'#fff'}}>Article not found</h2>
          <button className="btn-primary" onClick={() => navigate('/home')}>Go Home</button>
        </div>
      </div>
    );
  }

  return (
    <div className="page-wrap">
      <Nav />
      <div className="page" style={{maxWidth:720,margin:'0 auto',padding:'24px 16px'}}>
        <button onClick={() => navigate(-1)} style={{background:'none',border:'none',color:'#14b8a6',cursor:'pointer',fontSize:16,marginBottom:16}}>\u2190 Back</button>
        <div style={{fontSize:48,marginBottom:16}}>{article.icon}</div>
        <h1 style={{color:'#fff',fontSize:26,marginBottom:8}}>{article.title}</h1>
        <p style={{color:'#888',marginBottom:24,fontStyle:'italic'}}>{article.teaser}</p>
        <div style={{color:'#ccc',lineHeight:1.8,fontSize:16}}>
          {article.content?.map((p, idx) => (
            <p key={idx} style={{marginBottom:16}}>{p}</p>
          ))}
        </div>
        <button onClick={() => navigate('/home')} style={{marginTop:24,background:'#14b8a6',color:'#000',border:'none',padding:'10px 24px',borderRadius:8,cursor:'pointer',fontWeight:600}}>Back to Home</button>
      </div>
    </div>
  );
};

// ==================== EDIT PROFILE PAGE ====================
const EditProfilePage = () => {
  const { token, user, refreshUser, config } = useAuth();
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);

  const [name, setName] = useState(user?.name || '');
  const [bio, setBio] = useState(user?.bio || '');
  const [city, setCity] = useState(user?.location?.city || '');
  const [gender, setGender] = useState(user?.gender || '');
  const [profileType, setProfileType] = useState(user?.profile_type || '');
  const [seeking, setSeeking] = useState(user?.seeking || []);
  const [lookingFor, setLookingFor] = useState(user?.looking_for || []);
  const [interests, setInterests] = useState(user?.interests || []);
  const [desires, setDesires] = useState(user?.desires || []);

  useEffect(() => {
    if (!user) return;
    setName(user.name || '');
    setBio(user.bio || '');
    setCity(user.location?.city || '');
    setGender(user.gender || '');
    setProfileType(user.profile_type || '');
    setSeeking(user.seeking || []);
    setLookingFor(user.looking_for || []);
    setInterests(user.interests || []);
    setDesires(user.desires || []);
  }, [user?.id]);

  const toggle = (arr, setArr, val) => {
    setArr(prev => prev.includes(val) ? prev.filter(x => x !== val) : [...prev, val]);
  };

  const save = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/users/me`, {
        name, bio, gender, profile_type: profileType,
        location: { city },
        seeking, looking_for: lookingFor,
        interests, desires,
      }, { headers: { Authorization: `Bearer ${token}` } });
      await refreshUser?.();
      navigate('/profile');
    } catch (e) {
      alert(e?.response?.data?.detail || 'Failed to save profile');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="page-wrap">
      <Nav />
      <div className="page" style={{maxWidth:600,margin:'0 auto',padding:'24px 16px'}}>
        <div className="page-head">
          <button className="btn-back" onClick={() => navigate(-1)}>←</button>
          <h2>Edit Profile</h2>
        </div>

        <div className="form">
          <label>Name</label>
          <input value={name} onChange={(e) => setName(e.target.value)} data-testid="edit-name" />

          <label>City</label>
          <select value={city} onChange={e => setCity(e.target.value)} data-testid="edit-city">
            <option value="">Select City</option>
            {config?.cities?.map(c => <option key={c.name} value={c.name}>{c.name}</option>)}
          </select>

          <label>Gender</label>
          <select value={gender} onChange={e => setGender(e.target.value)} data-testid="edit-gender">
            <option value="">Select</option>
            {config?.genders?.map(g => <option key={g.value} value={g.value}>{g.label}</option>)}
          </select>

          <label>Profile Type</label>
          <select value={profileType} onChange={e => setProfileType(e.target.value)} data-testid="edit-profile-type">
            <option value="">Select</option>
            {config?.profile_types?.map(p => <option key={p.value} value={p.value}>{p.label}</option>)}
          </select>

          <label>Bio</label>
          <textarea rows={4} value={bio} onChange={(e) => setBio(e.target.value)} data-testid="edit-bio" />

          <div className="pref-section">
            <h3>Who Are You Seeking?</h3>
            <div className="check-grid cols-2">
              {config?.seeking?.map(o => (
                <label key={o.value} className={seeking.includes(o.value) ? 'sel' : ''}>
                  <input type="checkbox" checked={seeking.includes(o.value)} onChange={() => toggle(seeking, setSeeking, o.value)} />
                  {o.label}
                </label>
              ))}
            </div>
          </div>

          <div className="pref-section">
            <h3>What Are You Looking For?</h3>
            <div className="check-grid cols-2">
              {config?.looking_for?.map(o => (
                <label key={o.value} className={lookingFor.includes(o.value) ? 'sel' : ''}>
                  <input type="checkbox" checked={lookingFor.includes(o.value)} onChange={() => toggle(lookingFor, setLookingFor, o.value)} />
                  {o.label}
                </label>
              ))}
            </div>
          </div>

          <div className="pref-section">
            <h3>Interests</h3>
            <div className="check-grid cols-3">
              {config?.interests?.map(o => (
                <label key={o.value} className={`sm ${interests.includes(o.value) ? 'sel' : ''}`}>
                  <input type="checkbox" checked={interests.includes(o.value)} onChange={() => toggle(interests, setInterests, o.value)} />
                  {o.label}
                </label>
              ))}
            </div>
          </div>

          <button className="btn-primary" data-testid="edit-save" onClick={save} disabled={saving}>
            {saving ? 'Saving...' : 'Save Changes'}
          </button>
        </div>
      </div>
    </div>
  );
};


// APP
export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<AuthPage />} />
          <Route path="/login" element={<AuthPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/home" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
          <Route path="/meet" element={<ProtectedRoute><MeetPage /></ProtectedRoute>} />
          <Route path="/search" element={<Navigate to="/meet" />} />
          <Route path="/socials" element={<ProtectedRoute><SocialsPage /></ProtectedRoute>} />
          <Route path="/media" element={<ProtectedRoute><MediaPage /></ProtectedRoute>} />
          <Route path="/inbox" element={<ProtectedRoute><InboxPage /></ProtectedRoute>} />
          <Route path="/matches" element={<ProtectedRoute><MatchesPage /></ProtectedRoute>} />
          <Route path="/messages" element={<ProtectedRoute><MessagesPage /></ProtectedRoute>} />
          <Route path="/messages/:id" element={<ProtectedRoute><ChatPage /></ProtectedRoute>} />
          <Route path="/membership" element={<ProtectedRoute><MembershipPage /></ProtectedRoute>} />
          <Route path="/store" element={<ProtectedRoute><StorePage /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
          <Route path="/profile/edit" element={<ProtectedRoute><EditProfilePage /></ProtectedRoute>} />
          <Route path="/notifications" element={<ProtectedRoute><NotificationsPage /></ProtectedRoute>} />
          <Route path="/articles/:slug" element={<ProtectedRoute><ArticlePage /></ProtectedRoute>} />
          <Route path="/user/:id" element={<ProtectedRoute><UserProfilePage /></ProtectedRoute>} />
          <Route path="/activity/views" element={<ProtectedRoute><ActivityPage type="views" /></ProtectedRoute>} />
          <Route path="/activity/likes" element={<ProtectedRoute><ActivityPage type="likes" /></ProtectedRoute>} />
          <Route path="/winks" element={<ProtectedRoute><WinksPage /></ProtectedRoute>} />
          <Route path="/events" element={<ProtectedRoute><EventsPage /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
          <Route path="/forum" element={<ProtectedRoute><ForumPage /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/articles/:slug" element={<ProtectedRoute><ArticlePage /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        {/* Analytics removed */}
      </AuthProvider>
    </BrowserRouter>
  );
}